import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _typeof from "@babel/runtime/helpers/typeof";
import _omit from "lodash/omit";
import _map from "lodash/map";
import _isNil from "lodash/isNil";
import _omitBy from "lodash/omitBy";
import _mapValues from "lodash/mapValues";
import _set from "lodash/set";
import _keys from "lodash/keys";
import _size from "lodash/size";
import _pick from "lodash/pick";
import _get from "lodash/get";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import lodashUnion from 'lodash/union';
import { getCookies } from '@nerdwallet/api-sdk-core';
import UserDataPlatformSDK from './user-data-platform-sdk';
import serviceHTTPHelper from './service-http-helper';
import VisitorIdentitySDK from './visitor-identity-sdk';
import TransunionSDK from './transunion-sdk';
import dataApiFactory from './data-api-factory'; // ---- Constants ----
// This is a subset of the `APPS` found at: https://github.com/NerdWallet/identity-acls/blob/61382dfecb064e7b01e68f860658930569473228/acls/build-js/acls.js#L32-L34
// The three keys below should be kept in sync with that file (but those values haven't changed for years)
// *Note* this is legacy stuff that predates app-configs, and this code search helped find out the values needed below: https://github.com/search?q=org%3ANerdWallet+IdentitySDK.APPS&type=Code
// Going forward apps should get these values from their app-configs, not from constants here.
// TODO: replace product app's usage of these constants with app-configs values

var APPS = {
  NERDWALLET_MOBILE: 'nerdwallet-mobile',
  NERDWALLET_WEB: 'nerdwallet web',
  NWADMIN: 'nwadmin'
}; // Must be kept in sync w/ identity.nerdwallet src.flask_app.canonical_objects.profiles.Profiles

var PROFILES = {
  AAA_PROFILE: 'aaa_profile',
  ASSETS_PROFILE: 'assets_profile',
  AUTO_INSURANCE_PROFILE: 'auto_insurance_profile',
  BANKING_PROFILE: 'banking_profile',
  BUSINESS_PROFILE: 'business_profile',
  CARD_LINKED_OFFERS_PROFILE: 'card_linked_offers_profile',
  CREDIT_CARD_APPLICATION_PROFILE: 'credit_card_application_profile',
  DIT_EXPERT_PROFILE: 'dit_expert_profile',
  DIT_USER_PROFILE: 'dit_user_profile',
  EDUCATION_PROFILE: 'education_profile',
  EDU_APPLICATION_PROFILE: 'edu_application_profile',
  FINANCIAL_INSTITUTION_PARTNER_PROFILE: 'financial_institution_partner_profile',
  FINANCIAL_PROFILE: 'financial_profile',
  FORECAST_PROFILE: 'forecast_profile',
  GLOBAL_PROFILE: 'global_profile',
  GOALS_PROFILE: 'goals_profile',
  HOME_CALCULATOR_PROFILE: 'home_calculator_profile',
  HOME_CONSUMER_PROFILE: 'home_consumer_profile',
  HOMEBUYER_JOURNEY_PROFILE: 'homebuyer_journey_profile',
  INVESTING_PROFILE: 'investing_profile',
  MOBILE_APP_PROFILE: 'mobile_app_profile',
  MORTGAGE_OFFER_PROFILE: 'mortgage_offer_profile',
  MORTGAGE_PROFILE: 'mortgage_profile',
  MORTGAGE_SHOPPING_PROFILE: 'mortgage_shopping_profile',
  MORTGAGE_SHOPPING_PROFILE_V2: 'mortgage_shopping_profile_v2',
  MORTGAGE_APPLICATION_PROFILE: 'mortgage_application_profile',
  MY_NERDWALLET_PROFILE: 'my_nerdwallet_profile',
  PERSONAL_LOANS_PROFILE: 'personal_loans_profile',
  PERSONAL_LOANS_APPLICATION_PROFILE: 'personal_loans_application_profile',
  SMB_APPLICATION_PROFILE: 'smb_application_profile',
  SUBSCRIPTION_PROFILE: 'subscription_profile',
  SUBSCRIPTION_PROFILE_V2: 'subscription_profile_v2',
  SUBSCRIPTION_PROFILE_V3: 'subscription_profile_v3',
  TERMS_OF_SERVICE_PROFILE: 'terms_of_service_profile',
  TU_AUTHENTICATION_STATUS_PROFILE: 'tu_authentication_status_profile',
  TU_CREDIT_REPORT_PROFILE: 'tu_credit_report_profile',
  YODLEE_PROFILE: 'yodlee_profile',
  // this profile can only be set through the registration initalize endpoint
  REGISTRATION_TRACKING_PROFILE: 'registration_tracking_profile',
  ONBOARDING_PROFILE: 'onboarding_profile',
  CREDIT_BUILDER_PROFILE: 'credit_builder_profile'
};
var GOAL_TYPES = {
  SAVINGS_GOAL: 'savings_goal',
  DEBT_GOAL: 'debt_goal',
  HOME_GOAL: 'home_goal',
  RETIREMENT_GOAL: 'retirement_goal',
  CREDIT_GOAL: 'credit_goal'
};
var GOAL_SUBTYPES = {
  EMERGENCY_FUND: 'EMERGENCY_FUND',
  HOME: 'HOME',
  CAR: 'CAR',
  VACATION: 'VACATION',
  WEDDING: 'WEDDING',
  GENERIC: 'GENERIC'
};
var TRANSACTION_STATUS = {
  PENDING: 'PENDING',
  POSTED: 'POSTED',
  SCHEDULED: 'SCHEDULED'
}; // Must be kept in sync w/ identity.nerdwallet src.lib.emails.PASSWORD_RESET_URLS

var PASSWORD_RESET_URLS = {
  MY_NERDWALLET: 'mynw',
  AAA: 'aaa'
}; // Must be kept in sync w/ identity.nerdwallet src.lib.emails.EMAIL_VERIFICATION_URLS

var EMAIL_VERIFICATION_URLS = {
  MY_NERDWALLET: 'mynw',
  AAA: 'aaa',
  SWEEP: 'sweep'
}; // Must be kept in sync w/ identity.nerdwallet src.models.tos_acknowledgements.TOS_ACKNOWLEDGEMENT_TYPE

var TOS_ACKNOWLEDGEMENT_TYPE = {
  CREDIT_SCORE: 'CREDIT_SCORE',
  PERSONAL_LOAN_PREQUAL: 'PERSONAL_LOAN_PREQUAL'
}; // Must be kept in sync w/ identity.nerdwallet src.models.tos_acknowledgements.TOS_ACKNOWLEDGEMENT_SOURCE

var TOS_ACKNOWLEDGEMENT_SOURCE = {
  MY_NERDWALLET: 'MY_NERDWALLET',
  PERSONAL_LOAN: 'PERSONAL_LOAN'
};
var ACCOUNT_TYPES = {
  BANK: 'bank',
  CREDIT_CARD: 'creditCard',
  INVESTMENT: 'investment',
  INSURANCE: 'insurance',
  LOAN: 'loan',
  REWARD: 'reward',
  BILL: 'bill',
  OTHER: 'other'
};
var TRANSACTION_TAGS = {
  KEEP_AN_EYE: 'keep_an_eye',
  NOT_RECURRING: 'not_recurring',
  IGNORED: 'ignored'
};
var TRANSACTION_BASE_TYPES = {
  DEBIT: 'DEBIT',
  CREDIT: 'CREDIT'
};
var TRANSACTION_CATEGORIES = {
  OMIT: 'omit',
  INCOME: 'income',
  BILL: 'bill',
  FOOD: 'food',
  TRANSPORT: 'transport',
  OTHER: 'other'
};
var TRANSACTION_GROUP_BYS = {
  CANONICAL_MERCHANT_NAME: 'canonical_merchant_name',
  CATEGORY: 'category',
  CATEGORY_V2: 'category_v2',
  MERCHANT_NAME: 'merchant_name',
  MERCHANT_NAME_DS: 'merchant_name_ds',
  YODLEE_CATEGORY: 'yodlee_category',
  YODLEE_CATEGORY_ID: 'yodlee_category_id'
};
var TRANSACTION_SLICES = {
  MONTHLY: 'monthly',
  WEEKLY: 'weekly',
  WINDOW: 'window'
};
var ONBOARDING_TYPES = {
  BASIC: 'BASIC',
  CREDIT_SCORE: 'CREDIT_SCORE',
  ACCOUNT_AGG: 'ACCOUNT_AGG',
  CLO: 'CLO',
  SPENDING: 'SPENDING'
};
var ONBOARDING_INTEREST_TYPES = {
  CARDS: 'CARDS',
  CASH_FLOW: 'CASH_FLOW',
  CREDIT_SCORE: 'CREDIT_SCORE',
  DEBT: 'DEBT',
  GROW_MONEY: 'GROW_MONEY',
  NET_WORTH: 'NET_WORTH',
  REWARDS: 'REWARDS',
  SAVE_MONEY: 'SAVE_MONEY',
  SPENDING: 'SPENDING'
};
var CURRENT_SAVING_PATTERN_TYPES = {
  NOTHING: 'NOTHING',
  OCCASIONALLY: 'OCCASIONALLY',
  MONTHLY: 'MONTHLY'
};
var CURRENT_SPENDING_PATTERN_TYPES = {
  MORE_THAN_I_EARN: 'MORE_THAN_I_EARN',
  APPX_WHAT_I_EARN: 'APPX_WHAT_I_EARN',
  LESS_THAN_I_EARN: 'LESS_THAN_I_EARN'
};
var DEBT_TYPES = {
  CREDIT_DEBT: 'credit_debt',
  PERSONAL_LOAN_DEBT: 'personal_loan_debt',
  AUTO_LOAN_DEBT: 'auto_loan_debt',
  STUDENT_LOAN_DEBT: 'student_loan_debt',
  MORTGAGE_DEBT: 'mortgage_debt',
  MEDICAL_DEBT: 'medical_debt',
  PAYDAY_LOAN_DEBT: 'payday_loan_debt',
  OTHER_DEBT: 'other_debt'
};
var SAVING_TYPES = {
  MONTHLY_BILLS: 'monthly_bills',
  TRAVEL: 'travel',
  CAR_EXPENSES: 'car_expenses',
  HOME_COSTS: 'home_costs',
  CREDIT_CARD_INTEREST: 'credit_card_interest',
  STUDENT_LOANS: 'student_loans'
};
var SELF_REPORTED_CREDIT_SCORE_RANGES = {
  EXCELLENT: 'EXCELLENT_720_850',
  GOOD: 'GOOD_690_719',
  AVERAGE: 'AVERAGE_630_689',
  POOR: 'POOR_350_629'
};
var PRODUCT_SHOPPING_EVENT_NAMES = {
  CLICK: 'CLICK',
  IMPRESSION: 'IMPRESSION',
  PRODUCT_INTERACTION: 'PRODUCT_INTERACTION',
  TRANSACTION: 'TRANSACTION'
};
var PRODUCT_SHOPPING_ACTION_NAMES = {
  ADD: 'ADD',
  REMOVE: 'REMOVE',
  DRAWER_OPEN: 'DRAWER_OPEN',
  DRAWER_CLOSE: 'DRAWER_CLOSE',
  NONE: 'NONE',
  IN_PROGRESS: 'IN_PROGRESS',
  MONETIZED: 'MONETIZED'
};

function dataParserWithHeadersAndMeta(data, resp) {
  var dataWithHeadersAndMeta = _get(data, 'data'); // We want to add headers and meta without breaking the existing shape of the response
  // Data must have type object because you cannot set primitives with these properties


  if (dataWithHeadersAndMeta != null && _typeof(dataWithHeadersAndMeta) === 'object') {
    dataWithHeadersAndMeta.__headers = _get(resp, 'headers');
    dataWithHeadersAndMeta.__meta = _get(data, 'meta');
  }

  return dataWithHeadersAndMeta;
}

function dataParserWithHeadersAndMetaV2(data, resp) {
  return {
    data: _get(data, 'data'),
    headers: _get(resp, 'headers'),
    meta: _get(data, 'meta')
  };
}

var EMBEDDED_IDENTITY_PROFILES_PATH = 'data.identity.profiles';
/*
  v2 Identity profile API routes will have _v2 appended to them and use the v1 version route,
  but the Visitor profiles will NOT have _v2 appended and will use the v2 version route. We will
  minimize some of the ugliness here.
*/

function getV2ProfileType(profileType) {
  return "".concat(profileType, "_v2");
}
/*
  Helper to convert v1 include_profiles arguments to their v2 version.
  The v1 version is a list of profiles to be included, the v2 version is a map that specifies the desired version. In this case since users didn't originally specify the version, null will be used which returns the highest version available.
*/


function upgradeIncludeProfilesToV2(includeProfilesV1) {
  return includeProfilesV1.reduce(function (acc, elem) {
    acc[elem] = null;
    return acc;
  }, {});
} // ---- IdentitySDK ----
// IdentitySDK is a delicious sugary wrapper on top of ServiceSDK for Identity-related API calls.
// Note that IdentitySDK's API is based on ES6 Promises (which are awesome).  Read more at:
// - https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise
// - http://www.html5rocks.com/en/tutorials/es6/promises/


export default function IdentitySDK(ServiceSDK, config) {
  if (!config || _typeof(config) !== 'object') {
    throw new Error('A config object is required to initialize IdentitySDK');
  }

  var identityBaseUrl = config.identityBaseUrl;
  var identityAntifraudPass = config.identityAntifraudPass;

  var makeRouteBuilder = function makeRouteBuilder() {
    var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return function (endpoint) {
      return ServiceSDK.nwApiRoute(identityBaseUrl, 'api', version, endpoint);
    };
  };

  var identityRoute = makeRouteBuilder(1);
  var identityRouteV2 = makeRouteBuilder(2);
  var identityV2DataApiFactory = dataApiFactory(ServiceSDK, identityRouteV2);
  var responseHandlerOptions;

  if (config.enableHeadersAndMeta) {
    responseHandlerOptions = {
      dataParser: dataParserWithHeadersAndMeta
    };
  }

  var serviceV1 = serviceHTTPHelper(ServiceSDK, identityRoute, responseHandlerOptions);
  var serviceV2 = serviceHTTPHelper(ServiceSDK, identityRouteV2, responseHandlerOptions); // ---- User Data Platform SDK Init ----

  var userDataPlatformBaseUrl = config.userDataPlatformBaseUrl;
  var userDataPlatformSDK;

  if (userDataPlatformBaseUrl) {
    userDataPlatformSDK = UserDataPlatformSDK(ServiceSDK, {
      userDataPlatformBaseUrl: userDataPlatformBaseUrl
    });
  } // ---- Visitor Identity SDK Init ----


  var visitorIdentityBaseUrl = config.visitorIdentityBaseUrl;
  var visitorIdentitySDK;

  if (visitorIdentityBaseUrl) {
    visitorIdentitySDK = VisitorIdentitySDK(ServiceSDK, {
      visitorIdentityBaseUrl: visitorIdentityBaseUrl
    });
  }

  function ensureVisitorIdentitySDK() {
    if (!visitorIdentitySDK) {
      throw new Error('visitorIdentitySDK not instantiated');
    }
  } // ---- Transunion SDK Init ----
  // Fallback to the identityBaseUrl for TU calls if there's no corresponding base url in config for backwards compatability


  var transunionBaseUrl = config.transunionBaseUrl;

  if (!transunionBaseUrl) {
    transunionBaseUrl = identityBaseUrl;
  }

  var transunionSDK;

  if (transunionBaseUrl) {
    transunionSDK = TransunionSDK(ServiceSDK, {
      transunionBaseUrl: transunionBaseUrl,
      identityAntifraudPass: identityAntifraudPass
    });
  }

  function ensureTransunionSDK() {
    if (!transunionSDK) {
      throw new Error('transunionSDK not instantiated');
    }
  } // Trigger for UDP member profile shims
  // This may also be a function that will be invoked with NO args. The function must return a boolean.
  //
  // When this flag is true, include_profiles calls will fetch UDP managed profiles via UDP's batch GET API for all
  // profiles requested that are also in UDPMemberProfilesList.


  var shimUDPConfig = _get(config, 'shimUDP', false); // This function must be invoked to check whether to access member profiles via UDP


  var shouldShimUDP = typeof shimUDPConfig === 'function' ? shimUDPConfig : function () {
    return shimUDPConfig;
  };

  var UDPMemberProfilesList = _get(config, 'UDPMemberProfilesList', []);

  function ensureUserDataPlatformSDK() {
    if (!userDataPlatformSDK) {
      throw new Error('userDataPlatformSDK not instantiated');
    }
  }

  function isUDPProfile(profile) {
    return UDPMemberProfilesList.includes(profile);
  }

  var TUProfilesList = _get(config, 'TUProfilesList', []);

  function isTUProfile(profile) {
    return TUProfilesList.includes(profile);
  } // ---- Identities Interface ----
  // Register (and log in) a new identity.  Optionally create identity profiles as part of call.
  // UDP profile writes are NOT supported and this function will yield an error if any UDP profiles are included.
  //
  // - profiles: {PROFILES.PROFILE_TYPE: profileObj}
  // - additionalRoles: [@nerdwallet/identity-acls.acls.ROLES.FOO.BAR]
  // - success: function ({identity: newIdentity, scopes: [...]})
  // - error: function (err, resp, data)


  function register(app, email, password, profiles, additionalRoles, emailVerificationUrlKey, includeProfiles, serverRequest, enableHeadersAndMeta) {
    includeProfiles = lodashUnion(includeProfiles || [], getProperties(profiles));
    var config = enableHeadersAndMeta ? {
      dataParser: dataParserWithHeadersAndMetaV2,
      identityProfilesPath: EMBEDDED_IDENTITY_PROFILES_PATH
    } : null;

    if (_typeof(includeProfiles) === 'object' && Array.isArray(includeProfiles) && includeProfiles.length > 0) {
      // Do not allow UDP profile writes
      var udpWriteProfiles = _pick(profiles, UDPMemberProfilesList);

      if (_size(udpWriteProfiles) > 0) {
        throw new Error("UDP profiles are not permitted in register: ".concat(_keys(udpWriteProfiles)));
      } // include profiles shim


      var _splitIncludeProfiles = splitIncludeProfiles(includeProfiles),
          identityProfiles = _splitIncludeProfiles.identityProfiles,
          udpProfiles = _splitIncludeProfiles.udpProfiles,
          tuProfiles = _splitIncludeProfiles.tuProfiles;

      var _data = {
        app: app,
        email: email,
        password: password,
        profiles: profiles,
        additional_roles: additionalRoles,
        email_verification_url_key: emailVerificationUrlKey
      };
      var identityPromise = serviceV1.post('register', _data, serverRequest, config);
      var includeProfilesByService = {
        identityProfiles: identityProfiles,
        udpProfiles: udpProfiles,
        tuProfiles: tuProfiles
      };
      return handleIdentityWithShimmedProfiles(identityPromise, includeProfilesByService, serverRequest, _get(config, 'identityProfilesPath'));
    } // No include profiles shim


    var data = {
      app: app,
      email: email,
      password: password,
      profiles: profiles,
      additional_roles: additionalRoles,
      email_verification_url_key: emailVerificationUrlKey
    };
    return serviceV1.post('register', data, serverRequest).then(function (result) {
      ServiceSDK.setUserLoggedIn();
      return result;
    });
  } // Get precanned security questions from Identity
  // - success: function ()
  // - error: function (err, resp, data)


  function getSecurityQuestions(serverRequest) {
    return serviceV1.get('security_questions', {}, serverRequest);
  } // Set security question and answer for identity
  // - question: String
  // - answer: String


  function setSecurityChallenge(question, answer, serverRequest) {
    return serviceV1.post('set_security_challenge', {
      question: question,
      answer: answer
    }, serverRequest);
  } // Looks up a user's security question from a password_reset_token
  // returns challenge if exists, None otherwise
  // - token: String (the password_reset_token)


  function lookupSecurityChallenge(token, serverRequest) {
    return serviceV1.post('lookup_security_challenge', {
      password_reset_token: token
    }, serverRequest);
  } // Request an OTP provision URL for the currently logged in identity.
  // - success: function ()
  // - error: function (err, resp, data)


  function requestOtpSecret(password, serverRequest) {
    var data = {
      password: password
    };
    return serviceV1.post('otp_secret', data, serverRequest);
  } // Deactivate OTP for currently logged in identity.
  // - success: function ()
  // - error: function (err, resp, data)


  function deactivateOtp(otpCode, serverRequest) {
    var data = {
      otp_code: otpCode
    };
    return serviceV1.delete('otp_secret', data, serverRequest);
  } // Verify the OTP code of the currently logged in identity.
  // - success: function ()
  // - error: function (err, resp, data)


  function verifyOtpCode(otpCode, serverRequest) {
    var data = {
      otp_code: otpCode
    };
    return serviceV1.post('verify_otp_code', data, serverRequest);
  } // Generate new OTP backup codes for currently logged in identity.
  // - success: function ()
  // - error: function (err, resp, data)


  function generateOtpBackupCodes(otpCode, serverRequest) {
    var data = {
      otp_code: otpCode
    };
    return serviceV1.post('regenerate_otp_backup_codes', data, serverRequest);
  } // Update the email of the currently logged in identity.
  // - success: function ()
  // - error: function (err, resp, data)


  function updateEmail(password, newEmail, serverRequest, config) {
    var data = {
      password: password,
      new_email: newEmail
    };
    return serviceV1.post('update_email', data, serverRequest, config);
  } // Update the password of the currently logged in identity.
  // - success: function ()
  // - error: function (err, resp, data)


  function updatePassword(oldPassword, newPassword, serverRequest) {
    var data = {
      old_password: oldPassword,
      new_password: newPassword
    };
    return serviceV1.post('update_password', data, serverRequest);
  } // Create a password for the currently logged in identity if it doesn't have one.
  // - success: function ()
  // - error: function (err, resp, data)


  function createPassword(password, serverRequest) {
    var data = {
      password: password
    };
    return serviceV1.post('create_password', data, serverRequest);
  } // Resend verification email for currently logged in identity.
  // - success: function ()
  // - error: function (err, resp, data)


  function resendVerificationEmail(emailVerificationUrlKey, serverRequest) {
    var data = {
      email_verification_url_key: emailVerificationUrlKey
    };
    return serviceV1.post('resend_verification_email', data, serverRequest);
  } // Verify the email of the identity associated with emailVerificationToken.
  // - success: function ()
  // - error: function (err, resp, data)


  function verify(emailVerificationToken, serverRequest) {
    var data = {
      email_verification_token: emailVerificationToken
    };
    return serviceV1.post('verify', data, serverRequest);
  } // Generate SMS verification code and send to phoneNumber.
  // - success: function ()
  // - error: function (err, resp, data)


  function sendSmsVerification(phoneNumber, serverRequest) {
    var data = {
      phone_number: phoneNumber
    };
    return serviceV1.post('send_sms_verification', data, serverRequest);
  } // Generate SMS verification code for verified phone number and send to phoneNumber.
  // - success: function ()
  // - error: function (err, resp, data)


  function sendSmsReverification(phoneNumber, serverRequest) {
    var data = {
      phone_number: phoneNumber,
      allow_reverification: true
    };
    return serviceV1.post('send_sms_verification', data, serverRequest);
  } // Verify SMS verification code.
  // - success: function ()
  // - error: function (err, resp, data)


  function verifySmsCode(smsVerificationCode, serverRequest) {
    var data = {
      sms_verification_code: smsVerificationCode
    };
    return serviceV1.post('verify_sms_code', data, serverRequest);
  } // Verify user's Google ReCaptcha response.
  // - success: function ()
  // - error: function (err, resp, data)


  function verifyGoogleRecaptcha(captchaValue, serverRequest) {
    var params = {
      recaptcha_value: captchaValue
    };
    return serviceV1.post('verify_google_recaptcha', params, serverRequest);
  } // Unsubscribe the identity associated with this token from the given subscription profile field.
  // - success: function ()
  // - error: function (err, resp, data)


  function unsubscribe(unsubscribeToken, subscriptionProfileField, serverRequest) {
    var data = {
      unsubscribe_token: unsubscribeToken,
      subscription_profile_field: subscriptionProfileField
    };
    return serviceV1.post('unsubscribe', data, serverRequest);
  } // Unsubscribe the identity associated with this token from the given subscription profile field.
  // - success: function ()
  // - error: function (err, resp, data)


  function unsubscribeV2(unsubscribeToken, subscriptionProfileField, serverRequest) {
    var data = {
      unsubscribe_token: unsubscribeToken,
      subscription_profile_field: subscriptionProfileField
    };
    return serviceV2.post('unsubscribe', data, serverRequest);
  } // Update the current subscription profile for an Identity using an update subscription
  // OTU token, as retrieved from a call to /unsubscribe (this is set as a cookie).
  // `updateSubscriptionToken` is optional since as a param since identity will check for the
  // cookie.
  // - success: function ()
  // - error: function (err, resp, data)


  function updateSubscription(subscriptionProfile, updateSubscriptionToken, serverRequest) {
    var data = {
      subscription_profile: subscriptionProfile,
      update_subscription_token: updateSubscriptionToken
    };
    return serviceV1.put('update_subscription', data, serverRequest);
  } // Update the current subscription profile for an Identity using an update subscription
  // OTU token, as retrieved from a call to /unsubscribe (this is set as a cookie).
  // `updateSubscriptionToken` is optional since as a param since identity will check for the
  // cookie.
  // - success: function ()
  // - error: function (err, resp, data)


  function updateSubscriptionV2(subscriptionProfile, updateSubscriptionToken, serverRequest) {
    var data = {
      subscription_profile: subscriptionProfile,
      update_subscription_token: updateSubscriptionToken
    };
    return serviceV2.put('update_subscription', data, serverRequest);
  } // Migrate Identity session verification records to new cookie_id
  // - success: function ()
  // - error: function (err, resp, data)


  function migrateVerificationRecords(newCookieId, serverRequest) {
    var data = {
      new_cookie_id: newCookieId
    };
    return serviceV1.post('migrate_verification_records', data, serverRequest);
  } // Set the current user's app lock status to enabled (or not). Users
  // with AppLock enabled will be given auth tokens with longer TTLs.
  // - isAppLockEnabled: whether App Lock is enabled for this user
  // - success: function ()
  // - error: function (err, resp, data)


  function setAppLockEnabled(isAppLockEnabled, serverRequest) {
    var data = {
      app_lock_enabled: isAppLockEnabled
    };
    return serviceV1.post('identities/me/app_lock', data, serverRequest);
  } // Send a password reset email to the identity assocated with email.  Fails silently for security
  // reasons if an identity is not found.
  // - reset_password_url_key: PASSWORD_RESET_URLS.APP_TYPE
  // - success: function ()
  // - error: function (err, resp, data)


  function sendPasswordResetEmail(email, resetPasswordUrlKey, serverRequest) {
    var data = {
      email: email,
      reset_password_url_key: resetPasswordUrlKey
    };
    return serviceV1.post('send_password_reset_email', data, serverRequest);
  } // Reset the password of the identity associated with passwordResetToken and log them out of all sessions.
  // - success: function ()
  // - error: function (err, resp, data)


  function resetPassword(passwordResetToken, password, challengeAnswer, serverRequest) {
    var data = {
      password_reset_token: passwordResetToken,
      password: password,
      challenge_answer: challengeAnswer
    };
    return serviceV1.post('reset_password', data, serverRequest);
  } // Deactivate (and log out) the currently logged in identity.
  // - success: function ()
  // - error: function (err, resp, data)


  function deactivate(serverRequest) {
    return serviceV1.post('deactivate', {}, serverRequest);
  } // Deactivate (and log out) the identity using a deactivate_token.
  // - success: function ()
  // - error: function (err, resp, data)


  function deactivateViaToken(deactivate_token, serverRequest) {
    return serviceV1.post('deactivate_via_token', {
      deactivate_token: deactivate_token
    }, serverRequest);
  } // Acknowledge & accept Terms of Services for the current logged in identity.
  // - tos_type: TOS_ACKNOWLEDGEMENT_TYPE.type
  // - tos_source: TOS_ACKNOWLEDGEMENT_SOURCE.source
  // - success: function ()
  // - error: function (err, resp, data)


  function acknowledgeTOS(tos_type, tos_source, tos_version, serverRequest) {
    var data = {
      type: tos_type,
      source: tos_source,
      version: tos_version
    };
    return serviceV1.post('tos/acknowledge', data, serverRequest);
  } // ---- Sessions Interface ----
  // If no csrf_token cookie is present, then hit the Identity Services init_csrf_session endpoint
  // browser should set cookie automatically from the response header.


  function initCsrfSessionFromClient() {
    return getCookies({
      url: identityRoute('init_csrf_session'),
      config: config
    }).then(function (cookies) {
      if (cookies.csrf_token) {
        return true;
      }

      return serviceV1.get('init_csrf_session', {});
    });
  } // Log in an identity.
  // - includeProfiles: [PROFILES.PROFILE_TYPE]
  // - success: function ({identity: authenticatedIdentity, scopes: [...]})
  // - error: function (err, resp, data)


  function login(app, email, password, includeProfiles, rememberMe, serverRequest, enableHeadersAndMeta, otpCode) {
    var config = enableHeadersAndMeta ? {
      dataParser: dataParserWithHeadersAndMetaV2,
      identityProfilesPath: EMBEDDED_IDENTITY_PROFILES_PATH
    } : null;

    if (_typeof(includeProfiles) === 'object' && Array.isArray(includeProfiles) && includeProfiles.length > 0) {
      // include profiles shim
      var _splitIncludeProfiles2 = splitIncludeProfiles(includeProfiles),
          identityProfiles = _splitIncludeProfiles2.identityProfiles,
          udpProfiles = _splitIncludeProfiles2.udpProfiles,
          tuProfiles = _splitIncludeProfiles2.tuProfiles;

      var _data2 = {
        app: app,
        email: email,
        password: password,
        remember_me: rememberMe,
        otp_code: otpCode || ''
      };
      var identityPromise = serviceV1.post('login', _data2, serverRequest, config);
      var includeProfilesByService = {
        identityProfiles: identityProfiles,
        udpProfiles: udpProfiles,
        tuProfiles: tuProfiles
      };
      return handleIdentityWithShimmedProfiles(identityPromise, includeProfilesByService, serverRequest, _get(config, 'identityProfilesPath'));
    } // No include profiles shim


    var data = {
      app: app,
      email: email,
      password: password,
      remember_me: rememberMe,
      otp_code: otpCode || ''
    };
    return serviceV1.post('login', data, serverRequest, config).then(function (result) {
      ServiceSDK.setUserLoggedIn();
      return result;
    });
  } // Creates an empty goal of a particular goal type so it can be store in the goals profile.
  // - goal: A goal instance object. It must have a goal_type. i.e. GOAL_TYPES.SAVINGS_GOAL
  // name: 'Save for Emergency Fund'


  function setGoal(_ref) {
    var goal = _ref.goal,
        serverRequest = _ref.serverRequest;
    return serviceV1.post("goals/".concat(goal.goal_type), goal, serverRequest);
  } // Updates a goal instance created previously with the rest of the fields fill in.
  // - goal: A goal instance object. It must have an id. { id: 'UUID', name: 'Save for x', ...fields }


  function configureGoal(_ref2) {
    var goal = _ref2.goal,
        serverRequest = _ref2.serverRequest;
    return serviceV1.put("goals/".concat(goal.goal_type), goal, serverRequest);
  } // Deletes a goal
  // - goal: A goal instance object. It must have an id. { id: 'UUID' }


  function deleteGoal(_ref3) {
    var goal = _ref3.goal,
        serverRequest = _ref3.serverRequest;
    return serviceV1.delete("goals/".concat(goal.id), {}, serverRequest);
  } // Log in an identity using Google.
  // - includeProfiles: [PROFILES.PROFILE_TYPE]
  // - success: function ({identity: authenticatedIdentity, scopes: [...]})
  // - error: function (err, resp, data)


  function loginViaGoogle(app, googleOauthToken, includeProfiles, profilesIfReg, rememberMe, password, serverRequest, enableHeadersAndMeta) {
    var config = enableHeadersAndMeta ? {
      dataParser: dataParserWithHeadersAndMetaV2,
      identityProfilesPath: EMBEDDED_IDENTITY_PROFILES_PATH
    } : null;

    if (_typeof(includeProfiles) === 'object' && Array.isArray(includeProfiles) && includeProfiles.length > 0) {
      // include profiles shim
      var _splitIncludeProfiles3 = splitIncludeProfiles(includeProfiles),
          identityProfiles = _splitIncludeProfiles3.identityProfiles,
          udpProfiles = _splitIncludeProfiles3.udpProfiles,
          tuProfiles = _splitIncludeProfiles3.tuProfiles;

      var _data3 = {
        app: app,
        password: password,
        remember_me: rememberMe,
        google_oauth_token: googleOauthToken,
        profiles: profilesIfReg
      };
      var identityPromise = serviceV1.post('login_via_google', _data3, serverRequest, config);
      var includeProfilesByService = {
        identityProfiles: identityProfiles,
        udpProfiles: udpProfiles,
        tuProfiles: tuProfiles
      };
      return handleIdentityWithShimmedProfiles(identityPromise, includeProfilesByService, serverRequest, _get(config, 'identityProfilesPath'));
    } // No include profiles shim


    var data = {
      app: app,
      password: password,
      remember_me: rememberMe,
      google_oauth_token: googleOauthToken,
      profiles: profilesIfReg
    };
    return serviceV1.post('login_via_google', data, serverRequest, config).then(function (result) {
      ServiceSDK.setUserLoggedIn();
      return result;
    });
  } // Log in an employee identity using our Corporate IDP (aka Okta).
  // To use this SDK, you'll need a valid corporate IDP access token (Obtained by an Oauth flow) and a client ID
  // from the app initiating the Oauth flow. Client applications must be registered with
  // our corporate IDP to use this SDK - contact Security to get a client ID number.


  function loginViaCorpIdp(app, accessToken, clientId, rememberMe, serverRequest, enableHeadersAndMeta) {
    var config = enableHeadersAndMeta ? {
      dataParser: dataParserWithHeadersAndMetaV2
    } : null;
    var data = {
      app: app,
      access_token: accessToken,
      client_id: clientId,
      remember_me: rememberMe
    };
    return serviceV1.post('login_via_corp_idp', data, serverRequest, config).then(function (result) {
      ServiceSDK.setUserLoggedIn();
      return result;
    });
  } // Log in an identity using Apple.
  // - authorizationCode: Code received by the client from Apple after a successful Apple authentication.
  // - includeProfiles: [PROFILES.PROFILE_TYPE]
  // - success: function ({identity: authenticatedIdentity, scopes: [...]})
  // - error: function (err, resp, data)


  function loginViaApple() {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        app = _ref4.app,
        authorizationCode = _ref4.authorizationCode,
        clientId = _ref4.clientId,
        firstName = _ref4.firstName,
        lastName = _ref4.lastName,
        email = _ref4.email,
        nonce = _ref4.nonce,
        redirectUri = _ref4.redirectUri,
        includeProfiles = _ref4.includeProfiles,
        profilesIfReg = _ref4.profilesIfReg,
        rememberMe = _ref4.rememberMe,
        password = _ref4.password,
        serverRequest = _ref4.serverRequest,
        enableHeadersAndMeta = _ref4.enableHeadersAndMeta;

    var config = enableHeadersAndMeta ? {
      dataParser: dataParserWithHeadersAndMetaV2,
      identityProfilesPath: EMBEDDED_IDENTITY_PROFILES_PATH
    } : null;
    var data = {
      app: app,
      password: password,
      authorization_code: authorizationCode,
      client_id: clientId,
      email: email,
      first_name: firstName,
      last_name: lastName,
      nonce: nonce,
      redirect_uri: redirectUri,
      remember_me: rememberMe,
      profiles: profilesIfReg
    };

    if (_typeof(includeProfiles) === 'object' && Array.isArray(includeProfiles) && includeProfiles.length > 0) {
      // include profiles shim
      var _splitIncludeProfiles4 = splitIncludeProfiles(includeProfiles),
          identityProfiles = _splitIncludeProfiles4.identityProfiles,
          udpProfiles = _splitIncludeProfiles4.udpProfiles,
          tuProfiles = _splitIncludeProfiles4.tuProfiles;

      var identityPromise = serviceV1.post('login_via_apple', data, serverRequest, config);
      var includeProfilesByService = {
        identityProfiles: identityProfiles,
        udpProfiles: udpProfiles,
        tuProfiles: tuProfiles
      };
      return handleIdentityWithShimmedProfiles(identityPromise, includeProfilesByService, serverRequest, _get(config, 'identityProfilesPath'));
    } // No include profiles shim


    return serviceV1.post('login_via_apple', data, serverRequest, config).then(function (result) {
      ServiceSDK.setUserLoggedIn();
      return result;
    });
  } // Log in an identity.
  // - includeProfiles: [PROFILES.PROFILE_TYPE]
  // - success: function ({identity: authenticatedIdentity, scopes: [...]})
  // - error: function (err, resp, data)


  function loginViaRefreshToken(app, refreshToken, includeProfiles, rememberMe, enableHeadersAndMeta) {
    var config = enableHeadersAndMeta ? {
      dataParser: dataParserWithHeadersAndMetaV2,
      identityProfilesPath: EMBEDDED_IDENTITY_PROFILES_PATH
    } : null;

    if (_typeof(includeProfiles) === 'object' && Array.isArray(includeProfiles) && includeProfiles.length > 0) {
      // include profiles shim
      var _splitIncludeProfiles5 = splitIncludeProfiles(includeProfiles),
          identityProfiles = _splitIncludeProfiles5.identityProfiles,
          udpProfiles = _splitIncludeProfiles5.udpProfiles,
          tuProfiles = _splitIncludeProfiles5.tuProfiles;

      var _data4 = {
        app: app,
        refresh_token: refreshToken,
        remember_me: rememberMe
      };
      var identityPromise = serviceV1.post('login_via_refresh_token', _data4, undefined, config);
      var includeProfilesByService = {
        identityProfiles: identityProfiles,
        udpProfiles: udpProfiles,
        tuProfiles: tuProfiles
      };
      return handleIdentityWithShimmedProfiles(identityPromise, includeProfilesByService, undefined, _get(config, 'identityProfilesPath'));
    } // No include profiles shim


    var data = {
      app: app,
      refresh_token: refreshToken,
      remember_me: rememberMe
    };
    return serviceV1.post('login_via_refresh_token', data, undefined, config).then(function (result) {
      ServiceSDK.setUserLoggedIn();
      return result;
    });
  } // This is a prototype endpoint used to rescope auth cookies to more specific
  // subdomains. After signing in, make this call and it will respond with
  // updated credentials via `Set-Cookie` header. Cookies that are updated include:
  // `access_token`, `csrf_token` and `member_identity_assertion_token`


  function bespokeStageGetIdentityTokens(refreshToken, useNewDomain, app, serverRequest) {
    return serviceV1.post('bespoke_stage_get_identity_tokens', {
      use_new_domain: useNewDomain || false,
      refresh_token: refreshToken || null,
      app: app
    }, serverRequest);
  } // This is a prototype endpoint used to expire any auth cookies scoped to
  // the `.nerdwallet.biz` subdomain, preserving ones scoped to `.stage.nerdwallet.biz`


  function bespokeExpireIdentityTokens(useNewDomain, serverRequest) {
    return serviceV1.post('bespoke_expire_identity_tokens', {
      use_new_domain: useNewDomain || false
    }, serverRequest);
  } // Generate a one-time transfer token for a cookie_id
  // - success: function ({
  //     one_time_cookie_id_transfer_token,
  //     one_time_cookie_id_transfer_token_max_age
  //   })
  // - error: function (err, resp, data)


  function generateOneTimeCookieIdTransferToken(serverRequest) {
    return serviceV1.post('generate_one_time_cookie_id_transfer_token', {}, serverRequest);
  } // Generate a one-time login token for the currently logged-in identity
  // - success: function ({one_time_login_token, one_time_login_token_max_age})
  // - error: function (err, resp, data)


  function generateOneTimeLoginToken(serverRequest) {
    return serviceV1.post('generate_one_time_login_token', {}, serverRequest);
  } // Log in an identity using a one-time token
  // - includeProfiles: [PROFILES.PROFILE_TYPE]
  // - success: function ({identity: authenticatedIdentity, scopes: [...]})
  // - error: function (err, resp, data)


  function loginViaOneTimeToken(app, token, deviceID, includeProfiles, rememberMe, serverRequest, enableHeadersAndMeta) {
    var config = enableHeadersAndMeta ? {
      dataParser: dataParserWithHeadersAndMetaV2,
      identityProfilesPath: EMBEDDED_IDENTITY_PROFILES_PATH
    } : null;

    if (_typeof(includeProfiles) === 'object' && Array.isArray(includeProfiles) && includeProfiles.length > 0) {
      // include profiles shim
      var _splitIncludeProfiles6 = splitIncludeProfiles(includeProfiles),
          identityProfiles = _splitIncludeProfiles6.identityProfiles,
          udpProfiles = _splitIncludeProfiles6.udpProfiles,
          tuProfiles = _splitIncludeProfiles6.tuProfiles;

      var _data5 = {
        app: app,
        one_time_login_token: token,
        hashed_device_id: deviceID,
        remember_me: rememberMe
      };
      var identityPromise = serviceV1.post('login_via_one_time_login_token', _data5, serverRequest, config);
      var includeProfilesByService = {
        identityProfiles: identityProfiles,
        udpProfiles: udpProfiles,
        tuProfiles: tuProfiles
      };
      return handleIdentityWithShimmedProfiles(identityPromise, includeProfilesByService, serverRequest, _get(config, 'identityProfilesPath'));
    } // No include profiles shim


    var data = {
      app: app,
      one_time_login_token: token,
      hashed_device_id: deviceID,
      remember_me: rememberMe
    };
    return serviceV1.post('login_via_one_time_login_token', data, serverRequest, config).then(function (result) {
      ServiceSDK.setUserLoggedIn();
      return result;
    });
  } // Get the currently logged in identity.
  // - includeProfiles: [PROFILES.PROFILE_TYPE]
  // - success: function ({identity: authenticatedIdentity, scopes: [...]})
  // - error: function (err, resp, data)


  function getLoggedInIdentity(includeProfiles, serverRequest) {
    if (_typeof(includeProfiles) === 'object' && Array.isArray(includeProfiles) && includeProfiles.length > 0) {
      // include profiles shim
      var _splitIncludeProfiles7 = splitIncludeProfiles(includeProfiles),
          identityProfiles = _splitIncludeProfiles7.identityProfiles,
          udpProfiles = _splitIncludeProfiles7.udpProfiles,
          tuProfiles = _splitIncludeProfiles7.tuProfiles;

      var identityPromise = serviceV1.get('get_logged_in_identity', null, serverRequest);
      var includeProfilesByService = {
        identityProfiles: identityProfiles,
        udpProfiles: udpProfiles,
        tuProfiles: tuProfiles
      };
      return handleIdentityWithShimmedProfiles(identityPromise, includeProfilesByService, serverRequest, 'identity.profiles');
    } // No include profiles shim


    var loggedInPromise = serviceV1.get('get_logged_in_identity', null, serverRequest).then(function (result) {
      ServiceSDK.setUserLoggedIn();
      return result;
    });
    return loggedInPromise;
  } // Log out the currently logged in identity.
  // - success: function ()
  // - error: function (err, resp, data)


  function logout(serverRequest) {
    var loggedOutPromise = serviceV1.post('logout', {}, serverRequest).then(function (result) {
      ServiceSDK.setUserLoggedOut();
      return result;
    });
    return loggedOutPromise;
  } // ---- Admin Interface ----

  /**
   * Admin controller interface to get the specified identity.
   *
   * @param identityID {string} - UUID that uniquely identifies the user
   * @param includeProfiles {string[]}: [PROFILES.PROFILE_TYPE]
   * @param serverRequest {Request}: The express request for the server. Only necessary for server-side calls for extracting relevant headers.
   * @returns {Promise<*>} Promise object contains an authenticated identity and scopes
   */


  function adminGetIdentity(_x, _x2, _x3) {
    return _adminGetIdentity.apply(this, arguments);
  } // ---- TU Interface ----
  // Creates a TransUnion customer in the Identity codebase. This will often require verification questions, or further
  // information before the score and report details are provided
  // - customer: Object - The customer data provided by the user
  // - customer.trust_session_id: String - The session ID for TU digital verification
  // The customer object is passed in, instead of individual arguments because the
  // customer can include different data based on what the user provides.


  function _adminGetIdentity() {
    _adminGetIdentity = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(identityID, includeProfiles, serverRequest) {
      var _splitIncludeProfiles8, identityProfiles, udpProfiles, tuProfiles, identityProfilesMap, udpProfilesMap, tuProfilesMap, identityPromise, identityProfilePromise, udpPromise, tuPromise, responses, _responses2, identityResponse, identityProfileResponse, udpResponse, tuResponse;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // include profiles shim
              _splitIncludeProfiles8 = splitIncludeProfiles(includeProfiles), identityProfiles = _splitIncludeProfiles8.identityProfiles, udpProfiles = _splitIncludeProfiles8.udpProfiles, tuProfiles = _splitIncludeProfiles8.tuProfiles;
              identityProfilesMap = upgradeIncludeProfilesToV2(identityProfiles);
              udpProfilesMap = upgradeIncludeProfilesToV2(udpProfiles);
              tuProfilesMap = upgradeIncludeProfilesToV2(tuProfiles);
              identityPromise = serviceV1.get("identities/".concat(identityID), null, serverRequest);
              identityProfilePromise = getAnyProfilesV2(identityID, identityProfilesMap, serverRequest);
              udpPromise = userDataPlatformSDK.member.getAnyProfilesV2(identityID, udpProfilesMap, serverRequest);
              tuPromise = transunionSDK.profiles.getAnyProfilesV2(identityID, tuProfilesMap, serverRequest);
              _context.next = 10;
              return Promise.all([identityPromise, identityProfilePromise, udpPromise, tuPromise]);

            case 10:
              responses = _context.sent;
              // Combine the UDP and Identity profiles into the identity response
              _responses2 = _slicedToArray(responses, 4), identityResponse = _responses2[0], identityProfileResponse = _responses2[1], udpResponse = _responses2[2], tuResponse = _responses2[3];

              _set(identityResponse, 'identity.profiles', _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _get(identityResponse, 'identity.profiles')), _mapValues(identityProfileResponse, removeLogicalModelMetadata)), _mapValues(udpResponse, removeLogicalModelMetadata)), _mapValues(tuResponse, removeLogicalModelMetadata)));

              return _context.abrupt("return", identityResponse);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _adminGetIdentity.apply(this, arguments);
  }

  function createTUCustomer(data, serverRequest) {
    ensureTransunionSDK();
    return transunionSDK.createTUCustomer(data, serverRequest);
  } // Sends answers about the TU Customer to the authentication endpoint to verify identity
  // - answers - Array
  // Each item in the array is a dict with answer_id and question_id


  function authenticateTUCustomer(answers, serverRequest) {
    ensureTransunionSDK();
    return transunionSDK.authenticateTUCustomer(answers, serverRequest);
  } // Normally enrollment happens as part of `authenticateTUCustomer`
  // In some cases, enrollment doesn't complete and our users end up in an 'AUTHENTICATED' state
  // rather than 'ACTIVE'. This endpoint is a means to complete enrollment without starting over.


  function enrollTUCustomer(serverRequest) {
    ensureTransunionSDK();
    return transunionSDK.enrollTUCustomer(serverRequest);
  } // Forces a refresh of a user's TU credit report profile. For contractual reasons this should
  // only be called in response to a user action related to an alert.
  // - success: function(TUAuthenticationStatusProfile)
  // - error: function(err, response, data)


  function refreshTUCreditProfile(serverRequest) {
    ensureTransunionSDK();
    return transunionSDK.refreshTUCreditProfile(serverRequest);
  } // Deactivates a user's TU credit report subscriptions and purges all persistant data
  // - success: function(TUAuthenticationStatusProfile)
  // - error: function(err, response, data)


  function deactivateTUCustomer(serverRequest) {
    ensureTransunionSDK();
    return transunionSDK.deactivateTUCustomer(serverRequest);
  } // Retrieves the credit score for the current user - if it exists
  // - success: function ({vantage_score_3: some_score})
  // - error: function (err, resp, data)
  //    - NotFoundError - User needs to authenticate for TU
  //    - PreconditionFailedError - Can not retrieve credit score at this time


  function getCreditScore(serverRequest) {
    ensureTransunionSDK();
    return transunionSDK.getCreditScore(serverRequest);
  } // Retrieves the credit score for the current user - if it exists
  // - success: function ({creditFactor: some_value})
  // - error: function (err, resp, data)
  //    - NotFoundError - User needs to authenticate for TU
  //    - PreconditionFailedError - Can not retrieve credit score at this time


  function getCreditFactor(creditFactor, serverRequest) {
    ensureTransunionSDK();
    return transunionSDK.getCreditFactor(creditFactor, serverRequest);
  } // Retrieves a user's credit factor history for a provided date window, including the entire duration of the end_date
  // - creditFactor: name of requested credit factor [REQUIRED]
  // - startDate: inclusive start of history window [REQUIRED]
  // - endDate: inclusive end of history window [REQUIRED]
  // - interval: type of interval, 'week' or 'month'


  function getCreditFactorHistory(creditFactor, startDate, endDate, interval, serverRequest) {
    ensureTransunionSDK();
    return transunionSDK.getCreditFactorHistory(creditFactor, startDate, endDate, interval, serverRequest);
  } // Retrieves the simulated credit score for the current user given the score modifiers
  // - args is a dict where keys will be from the following list and value will be values for those modifiers
  //    - on_time_payments_num_months: maintain on time payments for # of months (int)
  //    - close_oldest_credit_card: close the oldest credit card (bool)
  //    - one_account_past_due_num_days: let one account go past due (str: 30,60,90)
  //    - all_accounts_past_due_num_days: let all accounts go past due (str: 30,60,90)
  //    - increase_credit_balance_amount: increase credit card balance by amount (int)
  //    - decrease_credit_balance_amount: decreasecredit card balance by amount (int)
  //    - increase_credit_card_limit: increase credit card limit by amount (int)
  //    - move_one_account_into_collection: let one account go into collection (bool)
  //    - add_tax_lien: add a tax lien to public record(bool)
  //    - add_wage_garnishment: add a wage garnishment to public record(bool)
  //    - add_foreclosure: add foreclosure to public record(bool)
  //    - add_child_support: add child support to public record(bool)
  //    - pay_off_all_credit_cards: pay off all credit cards (bool)
  //    - apply_for_number_of_credit_card: apply for number of credit cards (int)
  //    - obtain_credit_card_limit: obtain credit card with limit (int)
  //    - obtain_mortgage_limit: obtain mortgage with limit (int)
  //    - obtain_auto_loan_limit: obtain auto loan with limit (int)
  //    - obtain_personal_loan_limit: obtain personal loan with limit (int)
  //    - transfer_credit_balance_amount: transfer credit balance amount (int)
  // - success: function ({simulated_vantage_score: some_value})
  // - error: function (err, resp, data)


  function simulateVantageScore(args, serverRequest) {
    ensureTransunionSDK();
    return transunionSDK.simulateVantageScore(args, serverRequest);
  } // Retrieves a TU alert by ID
  // - alertId: ID of the requested TU alert


  function getCreditProfileAlert(alertId, serverRequest) {
    ensureTransunionSDK();
    return transunionSDK.getCreditProfileAlert(alertId, serverRequest);
  } // Retrieves all TU alerts within a range
  // - startDate: inclusive start of window (treats as date without time)
  // - endDate: inclusive end of window (treats as date without time)


  function getCreditProfileAlerts(startDate, endDate, serverRequest) {
    ensureTransunionSDK();
    return transunionSDK.getCreditProfileAlerts(startDate, endDate, serverRequest);
  } // Retrieves a list of credit factor changes, in order of descending importance


  function getCreditProfileRecentChanges(serverRequest) {
    ensureTransunionSDK();
    return transunionSDK.getCreditProfileRecentChanges(serverRequest);
  } // ---- Profiles Interface ----
  // ---- My profile functions (currently authenticated identity) ----

  /*
    Get batch profiles API for identity, optionally specifying API versions for each profile.
    - includeProfiles: {profile_name: api_version}
     If api_version is null, the default behavior is to use the highest api version. New clients should
    explicitly choose an api version to avoid unexpected version changes.
     Example usage:
      sdk = IdentitySDK(serviceSDK, {identityBaseUrl: ...});
      sdk.profiles.getProfilesV2({'global_profile': 1}, serverRequest).then(...);
  */


  function getProfilesV2() {
    var includeProfiles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var serverRequest = arguments.length > 1 ? arguments[1] : undefined;
    var apiFactory = identityV2DataApiFactory.getSingularIdentityEntityAPI('profiles');
    var params = {
      include_profiles: JSON.stringify(includeProfiles)
    };
    return apiFactory.getMy(params, serverRequest);
  } // Create a profile of type profileType for the currently logged in identity.
  // - profileType: PROFILES.PROFILE_TYPE
  // - success: function ()
  // - error: function (err, resp, data)


  function createMyProfile(identity, profileType, profileData, serverRequest) {
    if (isUDPProfile(profileType)) {
      return userDataPlatformSDK.member.profileApi(profileType).postMy(profileData, serverRequest).then(function (response) {
        return removeLogicalModelMetadata(_get(response, 'item'));
      });
    }

    if (isTUProfile(profileType)) {
      return transunionSDK.profiles.profileApi(profileType).postMy(profileData, serverRequest).then(function (response) {
        return removeLogicalModelMetadata(_get(response, 'item'));
      });
    }

    return createProfile(identity, profileType, profileData, serverRequest);
  } // Read the profile of type profileType for the currently logged in identity.
  // - profileType: PROFILES.PROFILE_TYPE
  // - success: function ()
  // - error: function (err, resp, data)


  function readMyProfile(identity, profileType, serverRequest) {
    if (isUDPProfile(profileType)) {
      return userDataPlatformSDK.member.profileApi(profileType).getMy({}, serverRequest).then(function (response) {
        return removeLogicalModelMetadata(_get(response, 'item'));
      });
    }

    if (isTUProfile(profileType)) {
      return transunionSDK.profiles.profileApi(profileType).getMy({}, serverRequest).then(function (response) {
        return removeLogicalModelMetadata(_get(response, 'item'));
      });
    }

    return readProfile(identity, profileType, serverRequest);
  } // Update the profile of type profileType for the currently logged in identity.
  // - profileType: PROFILES.PROFILE_TYPE
  // - success: function ()
  // - error: function (err, resp, data)


  function updateMyProfile(identity, profileType, profileData, serverRequest) {
    if (isUDPProfile(profileType)) {
      return userDataPlatformSDK.member.profileApi(profileType).patchMy(profileData, serverRequest).then(function (response) {
        return removeLogicalModelMetadata(_get(response, 'item'));
      });
    }

    if (isTUProfile(profileType)) {
      return transunionSDK.profiles.profileApi(profileType).patchMy(profileData, serverRequest).then(function (response) {
        return removeLogicalModelMetadata(_get(response, 'item'));
      });
    }

    return updateProfile(identity, profileType, profileData, serverRequest);
  } // Delete the profile of type profileType for the currently logged in identity.
  // - profileType: PROFILES.PROFILE_TYPE
  // - success: function ()
  // - error: function (err, resp, data)


  function deleteMyProfile(identity, profileType, serverRequest) {
    if (isUDPProfile(profileType)) {
      return userDataPlatformSDK.member.profileApi(profileType).deleteMy(serverRequest).then(function () {
        return true;
      });
    }

    if (isTUProfile(profileType)) {
      return transunionSDK.profiles.profileApi(profileType).deleteMy(serverRequest).then(function () {
        return true;
      });
    }

    return deleteProfile(identity, profileType, serverRequest);
  } // ---- Any profile functions (Arbitrary identity) ----
  // These endpoints generally have different scope requirements than the 'My' functions above.

  /*
    Get batch profiles API for identity, optionally specifying API versions for each profile.
    - includeProfiles: {profile_name: api_version}
     If api_version is null, the default behavior is to use the highest api version. New clients should
    explicitly choose an api version to avoid unexpected version changes.
     Example usage:
      sdk = IdentitySDK(serviceSDK, {identityBaseUrl: ...});
      sdk.profiles.getProfilesV2({'global_profile': 1}, serverRequest).then(...);
  */


  function getAnyProfilesV2(identityID) {
    var includeProfiles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var serverRequest = arguments.length > 2 ? arguments[2] : undefined;
    var apiFactory = identityV2DataApiFactory.getSingularIdentityEntityAPI('profiles');
    var params = {
      include_profiles: JSON.stringify(includeProfiles)
    };
    return apiFactory.get(identityID, params, serverRequest);
  } // Create a profile of type profileType for any identity.
  //
  // - profileType: PROFILES.PROFILE_TYPE
  // - success: function ()
  // - error: function (err, resp, data)


  function createAnyProfile(identity, profileType, profileData, serverRequest) {
    if (isUDPProfile(profileType)) {
      return userDataPlatformSDK.member.profileApi(profileType).post(identity.id, profileData, serverRequest).then(function (response) {
        return removeLogicalModelMetadata(_get(response, 'item'));
      });
    }

    if (isTUProfile(profileType)) {
      return transunionSDK.profiles.profileApi(profileType).post(identity.id, profileData, serverRequest).then(function (response) {
        return removeLogicalModelMetadata(_get(response, 'item'));
      });
    }

    return createProfile(identity, profileType, profileData, serverRequest);
  } // Read the profile of type profileType for any identity.
  // - profileType: PROFILES.PROFILE_TYPE
  // - success: function ()
  // - error: function (err, resp, data)


  function readAnyProfile(identity, profileType, serverRequest) {
    if (isUDPProfile(profileType)) {
      return userDataPlatformSDK.member.profileApi(profileType).get(identity.id, {}, serverRequest).then(function (response) {
        return removeLogicalModelMetadata(_get(response, 'item'));
      });
    }

    if (isTUProfile(profileType)) {
      return transunionSDK.profiles.profileApi(profileType).get(identity.id, {}, serverRequest).then(function (response) {
        return removeLogicalModelMetadata(_get(response, 'item'));
      });
    }

    return readProfile(identity, profileType, serverRequest);
  } // Update the profile of type profileType for any identity.
  // - profileType: PROFILES.PROFILE_TYPE
  // - success: function ()
  // - error: function (err, resp, data)


  function updateAnyProfile(identity, profileType, profileData, serverRequest) {
    if (isUDPProfile(profileType)) {
      return userDataPlatformSDK.member.profileApi(profileType).patch(identity.id, profileData, serverRequest).then(function (response) {
        return removeLogicalModelMetadata(_get(response, 'item'));
      });
    }

    if (isTUProfile(profileType)) {
      return transunionSDK.profiles.profileApi(profileType).patch(identity.id, profileData, serverRequest).then(function (response) {
        return removeLogicalModelMetadata(_get(response, 'item'));
      });
    }

    return updateProfile(identity, profileType, profileData, serverRequest);
  } // Delete the profile of type profileType for any identity.
  // - profileType: PROFILES.PROFILE_TYPE
  // - success: function ()
  // - error: function (err, resp, data)


  function deleteAnyProfile(identity, profileType, serverRequest) {
    if (isUDPProfile(profileType)) {
      return userDataPlatformSDK.member.profileApi(profileType).delete(identity.id, serverRequest).then(function () {
        return true;
      });
    }

    if (isTUProfile(profileType)) {
      return transunionSDK.profiles.profileApi(profileType).delete(identity.id, serverRequest).then(function () {
        return true;
      });
    }

    return deleteProfile(identity, profileType, serverRequest);
  } // ---- The following profiles functions are DEPRECATED. ----
  // Please use My or Any namespaced profiles functions.
  // Create a profile of type profileType for the currently logged in identity.
  // - profileType: PROFILES.PROFILE_TYPE
  // - success: function ()
  // - error: function (err, resp, data)


  function createProfile(identity, profileType, profileData, serverRequest) {
    return serviceV1.post(profileUrl(identity.id, profileType), profileData, serverRequest);
  } // Read the profile of type profileType for the currently logged in identity.
  // - profileType: PROFILES.PROFILE_TYPE
  // - success: function ()
  // - error: function (err, resp, data)


  function readProfile(identity, profileType, serverRequest) {
    return serviceV1.get(profileUrl(identity.id, profileType), {}, serverRequest);
  } // Update the profile of type profileType for the currently logged in identity.
  // - profileType: PROFILES.PROFILE_TYPE
  // - success: function ()
  // - error: function (err, resp, data)


  function updateProfile(identity, profileType, profileData, serverRequest) {
    return serviceV1.put(profileUrl(identity.id, profileType), profileData, serverRequest);
  } // Delete the profile of type profileType for the currently logged in identity.
  // - profileType: PROFILES.PROFILE_TYPE
  // - success: function ()
  // - error: function (err, resp, data)


  function deleteProfile(identity, profileType, serverRequest) {
    return serviceV1.delete(profileUrl(identity.id, profileType), {}, serverRequest);
  } // _MemberOrVisitor profile functions are for the currently authenticated identity.
  // These will defer to 'me' routes in Identity and UDP
  // Create a profile of type profileType for the currently logged in member identity if logged in,
  // otherwise create a profile of type profileType for the current visitor identity.
  // - profileType: PROFILES.PROFILE_TYPE
  // - success: function ()
  // - error: function (err, resp, data)


  function createMemberOrVisitorProfile(isLoggedIn, identity, profileType, profileData, serverRequest) {
    if (isLoggedIn) {
      return createMyProfile(identity, profileType, profileData, serverRequest);
    }

    ensureUserDataPlatformSDK();
    var sdk = userDataPlatformSDK.visitor.profileApi(profileType);
    return sdk.postMy(profileData, serverRequest);
  } // Create a profile of type profileType for the currently logged in member identity if logged in,
  // otherwise create a profile of type profileType for the current visitor identity.
  // - profileType: PROFILES.PROFILE_TYPE
  // - success: function ()
  // - error: function (err, resp, data)


  function createMemberOrVisitorProfileV2(isLoggedIn, identity, profileType, profileData, serverRequest) {
    if (isLoggedIn) {
      if (isUDPProfile(profileType)) {
        return userDataPlatformSDK.member.profileApi(profileType, 2).postMy(profileData, serverRequest).then(function (response) {
          return removeLogicalModelMetadata(_get(response, 'item'));
        });
      } // Identity keys off of V2 CO but the API version stays at V1


      return serviceV1.post(profileUrl(identity.id, getV2ProfileType(profileType)), profileData, serverRequest);
    }

    ensureUserDataPlatformSDK();
    var version = 2;
    var sdk = userDataPlatformSDK.visitor.profileApi(profileType, version);
    return sdk.postMy(profileData, serverRequest);
  } // Read the profile of type profileType for the currently logged in identity.
  // - profileType: PROFILES.PROFILE_TYPE
  // - success: function ()
  // - error: function (err, resp, data)


  function readMemberOrVisitorProfile(isLoggedIn, identity, profileType, serverRequest) {
    if (isLoggedIn) {
      return readMyProfile(identity, profileType, serverRequest);
    }

    ensureUserDataPlatformSDK();
    var sdk = userDataPlatformSDK.visitor.profileApi(profileType);
    return sdk.getMy({}, serverRequest);
  } // Read the profile of type profileType for the currently logged in identity.
  // - profileType: PROFILES.PROFILE_TYPE
  // - success: function ()
  // - error: function (err, resp, data)


  function readMemberOrVisitorProfileV2(isLoggedIn, identity, profileType, serverRequest) {
    if (isLoggedIn) {
      if (isUDPProfile(profileType)) {
        return userDataPlatformSDK.member.profileApi(profileType, 2).getMy({}, serverRequest).then(function (response) {
          return removeLogicalModelMetadata(_get(response, 'item'));
        });
      } // Identity keys off of V2 CO but the API version stays at V1


      return serviceV1.get(profileUrl(identity.id, getV2ProfileType(profileType)), {}, serverRequest);
    }

    ensureUserDataPlatformSDK();
    var version = 2;
    var sdk = userDataPlatformSDK.visitor.profileApi(profileType, version);
    return sdk.getMy({}, serverRequest);
  } // Update the profile of type profileType for the currently logged in identity.
  // - profileType: PROFILES.PROFILE_TYPE
  // - success: function ()
  // - error: function (err, resp, data)


  function updateMemberOrVisitorProfile(isLoggedIn, identity, profileType, profileData, serverRequest) {
    if (isLoggedIn) {
      return updateMyProfile(identity, profileType, profileData, serverRequest);
    }

    ensureUserDataPlatformSDK();
    var sdk = userDataPlatformSDK.visitor.profileApi(profileType);
    return sdk.patchMy(profileData, serverRequest);
  } // Update the profile of type profileType for the currently logged in identity.
  // - profileType: PROFILES.PROFILE_TYPE
  // - success: function ()
  // - error: function (err, resp, data)


  function updateMemberOrVisitorProfileV2(isLoggedIn, identity, profileType, profileData, serverRequest) {
    if (isLoggedIn) {
      if (isUDPProfile(profileType)) {
        return userDataPlatformSDK.member.profileApi(profileType, 2).patchMy(profileData, serverRequest).then(function (response) {
          return removeLogicalModelMetadata(_get(response, 'item'));
        });
      } // Identity keys off of V2 CO but the API version stays at V1


      return serviceV1.put(profileUrl(identity.id, getV2ProfileType(profileType)), profileData, serverRequest);
    }

    ensureUserDataPlatformSDK();
    var version = 2;
    var sdk = userDataPlatformSDK.visitor.profileApi(profileType, version);
    return sdk.patchMy(profileData, serverRequest);
  } // Delete the profile of type profileType for the currently logged in identity.
  // - profileType: PROFILES.PROFILE_TYPE
  // - success: function ()
  // - error: function (err, resp, data)


  function deleteMemberOrVisitorProfile(isLoggedIn, identity, profileType, serverRequest) {
    if (isLoggedIn) {
      return deleteMyProfile(identity, profileType, serverRequest);
    }

    ensureUserDataPlatformSDK();
    var sdk = userDataPlatformSDK.visitor.profileApi(profileType);
    return sdk.deleteMy(serverRequest);
  } // Delete the profile of type profileType for the currently logged in identity.
  // - profileType: PROFILES.PROFILE_TYPE
  // - success: function ()
  // - error: function (err, resp, data)


  function deleteMemberOrVisitorProfileV2(isLoggedIn, identity, profileType, serverRequest) {
    if (isLoggedIn) {
      if (isUDPProfile(profileType)) {
        return userDataPlatformSDK.member.profileApi(profileType, 2).deleteMy(serverRequest).then(function () {
          return true;
        });
      } // Identity keys off of V2 CO but the API version stays at V1


      return serviceV1.delete(profileUrl(identity.id, getV2ProfileType(profileType)), {}, serverRequest);
    }

    ensureUserDataPlatformSDK();
    var version = 2;
    var sdk = userDataPlatformSDK.visitor.profileApi(profileType, version);
    return sdk.deleteMy(serverRequest);
  } // ---- Visitor Interface ----
  // Update the email of the logged out visitor identity.
  // - success: function ()
  // - error: function (err, resp, data)


  function updateVisitorEmail(newEmail, serverRequest) {
    ensureVisitorIdentitySDK();
    return visitorIdentitySDK.updateEmail(newEmail, serverRequest);
  } // Register an email only registered user (EORU) (fka visitor).
  // - success: function ()
  // - error: function (err, resp, data)


  function registerVisitor(email, rtp, serverRequest) {
    ensureVisitorIdentitySDK();
    return visitorIdentitySDK.register(email, rtp, serverRequest);
  } // Product Shopping Actions
  // Read PSA for the currently logged in identity
  // - event_name: PRODUCT_SHOPPING_EVENT_NAMES.EVENT_TYPE
  // @link https://nerdwallet.atlassian.net/wiki/spaces/ENG/pages/414154910/Product+Shopping+Actions+Integration+Guide


  function readMemberProductShoppingActions(_ref5) {
    var productID = _ref5.productID,
        eventName = _ref5.eventName,
        vertical = _ref5.vertical,
        action = _ref5.action,
        eventID = _ref5.eventID,
        url = _ref5.url,
        pageFunction = _ref5.pageFunction,
        occurredAtGTE = _ref5.occurredAtGTE,
        occurredAtLTE = _ref5.occurredAtLTE,
        productDisplayDriver = _ref5.productDisplayDriver,
        productDisplayDriverNE = _ref5.productDisplayDriverNE,
        serverRequest = _ref5.serverRequest;
    var data = {
      product_id: productID,
      event_name: eventName,
      vertical: vertical,
      action: action,
      url: url,
      event_id: eventID,
      page_function: pageFunction,
      occurred_at__gte: occurredAtGTE,
      occurred_at__lte: occurredAtLTE,
      product_display_driver: productDisplayDriver,
      product_display_driver__ne: productDisplayDriverNE
    }; // Omit null/undefined params, as the service doesn't handle these gracefully.

    var cleanedData = _omitBy(data, _isNil);

    if (shouldShimUDP()) {
      return userDataPlatformSDK.member.productShoppingActionsV2.getAllMy(cleanedData, serverRequest).then(function (response) {
        return _map(_get(response, 'items'), removeLogicalModelMetadata);
      });
    }

    return serviceV2.get(productShoppingActionUrl('me'), cleanedData, serverRequest);
  } // Create PSA for currently logged in identity
  // This is only valid on NON-PROD environments
  // - event_name: PRODUCT_SHOPPING_EVENT_NAMES.EVENT_TYPE
  // - action: PRODUCT_SHOPPING_ACTION_NAMES.ACTION_TYPE
  // @link https://nerdwallet.atlassian.net/wiki/spaces/ENG/pages/414154910/Product+Shopping+Actions+Integration+Guide


  function createMemberProductShoppingAction(_ref6) {
    var productID = _ref6.productID,
        eventName = _ref6.eventName,
        vertical = _ref6.vertical,
        action = _ref6.action,
        occurredAt = _ref6.occurredAt,
        url = _ref6.url,
        eventID = _ref6.eventID,
        pageFunction = _ref6.pageFunction,
        productDisplayDriver = _ref6.productDisplayDriver,
        serverRequest = _ref6.serverRequest;
    var data = {
      product_id: productID,
      event_name: eventName,
      vertical: vertical,
      action: action,
      occurred_at: occurredAt,
      url: url,
      event_id: eventID,
      page_function: pageFunction,
      product_display_driver: productDisplayDriver
    }; // Omit null/undefined params, as the service doesn't handle these gracefully.

    var cleanedData = _omitBy(data, _isNil);

    if (shouldShimUDP()) {
      return userDataPlatformSDK.member.productShoppingActionsV2.postMy(cleanedData, serverRequest).then(function (response) {
        return removeLogicalModelMetadata(_get(response, 'item'));
      });
    }

    return serviceV2.post(productShoppingActionUrl('me'), cleanedData, serverRequest);
  } // ---- Yodlee Interface ----


  var Yodlee = {
    // Search Yodlee providers
    // - query: string search query
    searchProviders: function searchProviders(_ref7) {
      var query = _ref7.query,
          serverRequest = _ref7.serverRequest;
      var url = 'providers/search';
      return serviceV1.get(url, {
        query: query
      }, serverRequest);
    },
    // Get details for a provider (including login form)
    // - providerId
    getProviderDetails: function getProviderDetails(_ref8) {
      var providerId = _ref8.providerId,
          serverRequest = _ref8.serverRequest;
      var url = 'providers/details';
      return serviceV1.get(url, {
        provider_id: providerId
      }, serverRequest);
    },
    // Log in to a provider
    // - providerId
    // - fields: array of key-value objects, e.g. `[{ key: value }, {key: value }]`
    // - add_iav: Whether to perform the instant account verification (IAV) check on the account
    // when logging in
    loginToProvider: function loginToProvider(_ref9) {
      var providerId = _ref9.providerId,
          fields = _ref9.fields,
          serverRequest = _ref9.serverRequest,
          _ref9$addIAV = _ref9.addIAV,
          addIAV = _ref9$addIAV === void 0 ? false : _ref9$addIAV;
      var url = 'providers/login';
      return serviceV1.post(url, {
        fields: fields,
        provider_id: providerId,
        add_iav: addIAV
      }, serverRequest);
    },
    // Endpoint to be used for existing provider accounts that have not been verified by Yodlee
    // (e.g. accounts linked before Sweep). The IAV endpoint will trigger the standard Yodlee login flow
    // (with no credentials passed by the client). The client will then have to poll the status endpoint
    // to check the state of the account and if MFA is required.
    attemptProviderIAV: function attemptProviderIAV(_ref10) {
      var providerAccountStateId = _ref10.providerAccountStateId,
          serverRequest = _ref10.serverRequest;
      var url = "provider_accounts/iav/".concat(providerAccountStateId);
      return serviceV1.post(url, null, serverRequest);
    },
    // Attempt MFA Challenge for a provider
    // - providerAccountId: note provider account id is not the same as provider id
    // - fields: array of key-value objects, e.g. `[{ key: value }, { key: value }]`
    // - add_iav: Whether to perform the instant account verification (IAV) check on the account
    // when logging in
    attemptProviderMFA: function attemptProviderMFA(_ref11) {
      var providerAccountId = _ref11.providerAccountId,
          fields = _ref11.fields,
          serverRequest = _ref11.serverRequest,
          _ref11$addIAV = _ref11.addIAV,
          addIAV = _ref11$addIAV === void 0 ? false : _ref11$addIAV;
      var url = "provider_accounts/".concat(providerAccountId, "/mfa");
      return serviceV1.post(url, {
        fields: fields,
        add_iav: addIAV
      }, serverRequest);
    },
    // Get the provider account object for a given provider account id
    // - providerAccountId: note provider account id is not the same as provider id
    getProviderAccountStatus: function getProviderAccountStatus(_ref12) {
      var providerAccountId = _ref12.providerAccountId,
          serverRequest = _ref12.serverRequest;
      var url = "provider_accounts/".concat(providerAccountId, "/status");
      return serviceV1.get(url, null, serverRequest);
    },
    // Update financial account data for a user - CRUD endpoints must be enabled in identity.
    // https://github.com/NerdWallet/identity.nerdwallet/blob/f0b97394122031e0403ca0beb3ecfc7205923177/src/identity/flask_app/controllers/financial_account_data_controller.py#L192
    // - accountId: the account to add the data to
    // - accountType: enum defined by FINANCIAL_ACCOUNT_DATA_TYPE_TO_CO_MAP in identity.nerdwallet - i.e. 'bank_accounts'
    // - data: Schema to update the account - defined by canonical for /financial_account_data
    putFinancialAccounts: function putFinancialAccounts() {
      var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          accountId = _ref13.accountId,
          accountType = _ref13.accountType,
          data = _ref13.data,
          serverRequest = _ref13.serverRequest;

      var url = "financial_account_data/".concat(accountType, "/").concat(accountId);
      return serviceV1.put(url, data, serverRequest);
    },
    // Delete financial account data for a user - CRUD endpoints must be enabled in identity.
    // - accountId: the account to add the data to
    // - accountType: enum defined by FINANCIAL_ACCOUNT_DATA_TYPE_TO_CO_MAP in identity.nerdwallet - i.e. 'bank_accounts'
    deleteFinancialAccounts: function deleteFinancialAccounts() {
      var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          accountId = _ref14.accountId,
          accountType = _ref14.accountType,
          serverRequest = _ref14.serverRequest;

      var url = "financial_account_data/".concat(accountType, "/").concat(accountId);
      return serviceV1.delete(url, {}, serverRequest);
    },
    // Create financial account data for a user - CRUD endpoints must be enabled in identity.
    // - data: Schema to create the account - defined by canonical for /financial_account_data
    postFinancialAccountData: function postFinancialAccountData() {
      var _ref15 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          data = _ref15.data,
          serverRequest = _ref15.serverRequest;

      var url = 'financial_account_data';
      return serviceV1.post(url, data, serverRequest);
    },
    // Update transaction data for a user - CRUD endpoints must be enabled in identity.
    // - data: Schema to update the transaction - defined by canonical for /financial_account_data
    putFinancialTransaction: function putFinancialTransaction() {
      var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          transactionId = _ref16.transactionId,
          data = _ref16.data,
          serverRequest = _ref16.serverRequest;

      var url = "financial_account_data/transactions/".concat(transactionId);
      return serviceV1.put(url, data, serverRequest);
    },
    // Delete transaction for a user - CRUD endpoints must be enabled in identity.\
    deleteFinancialTransaction: function deleteFinancialTransaction() {
      var _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          transactionId = _ref17.transactionId,
          serverRequest = _ref17.serverRequest;

      var url = "financial_account_data/transactions/".concat(transactionId);
      return serviceV1.delete(url, {}, serverRequest);
    },
    // Get one or all financial accounts for a user
    // - accountId: **optional** if accountId set it will query a single financial account. If not
    //   set it will query all financial accounts.
    getFinancialAccounts: function getFinancialAccounts() {
      var _ref18 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          accountId = _ref18.accountId,
          serverRequest = _ref18.serverRequest;

      var url = accountId ? "financial_accounts/".concat(accountId) : 'financial_accounts';
      return serviceV1.get(url, null, serverRequest);
    },
    // Set self-reported data on a financial account
    // - accountId: the account to add data to
    // - extraData: the additional data to add (1-level deep JSON object)
    setSelfReportedData: function setSelfReportedData() {
      var _ref19 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          accountId = _ref19.accountId,
          _ref19$extraData = _ref19.extraData,
          extraData = _ref19$extraData === void 0 ? {} : _ref19$extraData,
          serverRequest = _ref19.serverRequest;

      var url = "financial_accounts/".concat(accountId);
      return serviceV1.put(url, {
        extra_data: extraData
      }, serverRequest);
    },
    // Hides/shows the financial account by setting the nw_enabled flag on the account
    // - accountId: the account to hide or show
    // - nwEnabled: a bool representing whether the account's transactions are returned in
    // subsequent calls, as well as whether the account's balance is added to sum values.
    updateFinancialAccountVisibility: function updateFinancialAccountVisibility() {
      var _ref20 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          accountId = _ref20.accountId,
          nwEnabled = _ref20.nwEnabled,
          serverRequest = _ref20.serverRequest;

      var url = "financial_accounts/".concat(accountId);
      return serviceV1.put(url, {
        nw_enabled: nwEnabled
      }, serverRequest);
    },
    // Get one or all investment holdings for a user
    // - accountId: **optional** if accountId set it will query a single account's investment
    //   holdings. If not set it will query all investment accounts.
    getInvestmentHoldings: function getInvestmentHoldings() {
      var _ref21 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          accountId = _ref21.accountId,
          serverRequest = _ref21.serverRequest;

      var url = accountId ? "financial_accounts/investment_holdings/".concat(accountId) : 'financial_accounts/investment_holdings';
      return serviceV1.get(url, null, serverRequest);
    },

    /**
     * Get a rollup of transaction amounts for identity across all accounts.
     *
     * @deprecated Use {@link getTransactionsCashFlow} instead.
     *
     * @param accountId - **optional** if accountId set it will filter by that account's transactions
     * @param baseType - **optional** filter by transaction base_type
     * @param endDate - **optional** inclusive end date (ISO 8601 date, no time) of window (default today)
     * @param excludeAccountTypes - **optional** blacklist filter by account type
     * @param excludeCategories - **optional** blacklist filter by category
     * @param excludeSubtypes - **optional** blacklist filter by subtype
     * @param excludeTags - **optional** blacklist filter by tag
     * @param excludeTypes - **optional** blacklist filter by type
     * @param includeAccountTypes - **optional** whitelist filter by account type
     * @param includeCategories - **optional** whitelist filter by category
     * @param includeSubtypes - **optional** whitelist filter by subtype
     * @param includeTags - **optional** whitelist filter by tag
     * @param includeTypes - **optional** whitelist filter by type
     * @param merchantName - **optional** filter by merchant name substring
     * @param omit, income, bill, food, transport, other
     * @param startDate - **optional** inclusive start date (ISO 8601 date, no time) of window (default 30 days before today)
     * @param status - **optional** filter by transaction status
     *
     * @return {Promise} {'summary': sum of debit transactions}
     */
    getTransactionsSummary: function getTransactionsSummary() {
      var _ref22 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          accountId = _ref22.accountId,
          baseType = _ref22.baseType,
          endDate = _ref22.endDate,
          excludeAccountTypes = _ref22.excludeAccountTypes,
          excludeCategories = _ref22.excludeCategories,
          excludeSubtypes = _ref22.excludeSubtypes,
          excludeTags = _ref22.excludeTags,
          excludeTypes = _ref22.excludeTypes,
          includeAccountTypes = _ref22.includeAccountTypes,
          includeCategories = _ref22.includeCategories,
          includeSubtypes = _ref22.includeSubtypes,
          includeTags = _ref22.includeTags,
          includeTypes = _ref22.includeTypes,
          merchantName = _ref22.merchantName,
          serverRequest = _ref22.serverRequest,
          startDate = _ref22.startDate,
          status = _ref22.status;

      if (process.env !== 'production') {
        // eslint-disable-next-line no-console -- directive added automatically by Shepherd migration
        console.warn('getTransactionsSummary is deprecated. Use getTransactionsCashFlow instead.');
      }

      var params = _omitBy({
        account_id: accountId,
        base_type: baseType,
        end_date: endDate,
        exclude_account_types: JSON.stringify(excludeAccountTypes),
        exclude_categories: JSON.stringify(excludeCategories),
        exclude_subtypes: JSON.stringify(excludeSubtypes),
        exclude_tags: JSON.stringify(excludeTags),
        exclude_types: JSON.stringify(excludeTypes),
        include_account_types: JSON.stringify(includeAccountTypes),
        include_categories: JSON.stringify(includeCategories),
        include_subtypes: JSON.stringify(includeSubtypes),
        include_tags: JSON.stringify(includeTags),
        include_types: JSON.stringify(includeTypes),
        merchant_name: merchantName,
        start_date: startDate,
        status: status
      }, _isNil);

      var url = 'financial_accounts/transactions/summary';
      return serviceV1.get(url, params, serverRequest);
    },

    /**
     * Get a rollup of transaction debits for the current and previous months.
     *
     * @deprecated Prefer endpoints that don't rely on base_type (DEBIT and CREDIT)
     *
     * @param accountId - **optional** if accountId set it will filter by that account's transactions
     * @param category - **optional** filter by transaction category
     * @param excludeAccountTypes - **optional** blacklist filter by account type
     * @param excludeCategories - **optional** blacklist filter by category
     * @param excludeSubtypes - **optional** blacklist filter by subtype
     * @param excludeTags - **optional** blacklist filter by tag
     * @param excludeTypes - **optional** blacklist filter by type
     * @param includeAccountTypes - **optional** whitelist filter by account type
     * @param includeCategories - **optional** whitelist filter by category
     * @param includeSubtypes - **optional** whitelist filter by subtype
     * @param includeTags - **optional** whitelist filter by tag
     * @param includeTypes - **optional** whitelist filter by type
     * @param merchantName - **optional** filter by merchant name substring
     * @param status - **optional** filter by transaction status
     * @param today - **optional** a date representing the user's current date (ISO 8601 date, no time) If not provided, user is presumed in UTC timezone.
     *
     * @return {Promise} Returns {'sum_debits_this_month': sum of debit transactions this month, 'sum_debits_last_month': sum of debit transactions last month}
     */
    getTransactionsSummaryDebits: function getTransactionsSummaryDebits() {
      var _ref23 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          accountId = _ref23.accountId,
          excludeAccountTypes = _ref23.excludeAccountTypes,
          excludeCategories = _ref23.excludeCategories,
          excludeSubtypes = _ref23.excludeSubtypes,
          excludeTags = _ref23.excludeTags,
          excludeTypes = _ref23.excludeTypes,
          includeAccountTypes = _ref23.includeAccountTypes,
          includeCategories = _ref23.includeCategories,
          includeSubtypes = _ref23.includeSubtypes,
          includeTags = _ref23.includeTags,
          includeTypes = _ref23.includeTypes,
          merchantName = _ref23.merchantName,
          serverRequest = _ref23.serverRequest,
          status = _ref23.status,
          today = _ref23.today;

      if (process.env !== 'production') {
        // eslint-disable-next-line no-console -- directive added automatically by Shepherd migration
        console.warn("getTransactionsSummaryDebits is deprecated. Prefer endpoints that don't rely on base_type (DEBIT and CREDIT).");
      }

      var params = _omitBy({
        account_id: accountId,
        exclude_account_types: JSON.stringify(excludeAccountTypes),
        exclude_categories: JSON.stringify(excludeCategories),
        exclude_subtypes: JSON.stringify(excludeSubtypes),
        exclude_tags: JSON.stringify(excludeTags),
        exclude_types: JSON.stringify(excludeTypes),
        include_account_types: JSON.stringify(includeAccountTypes),
        include_categories: JSON.stringify(includeCategories),
        include_subtypes: JSON.stringify(includeSubtypes),
        include_tags: JSON.stringify(includeTags),
        include_types: JSON.stringify(includeTypes),
        merchant_name: merchantName,
        status: status,
        today: today
      }, _isNil);

      var url = 'financial_accounts/transactions/summary/debits';
      return serviceV1.get(url, params, serverRequest);
    },

    /**
     * Get monthly rollup sum of all transactions for target month by category
     *
     * @deprecated Use {@link getTransactionsCashFlowByCategories} instead.
     *
     * @param accountId - **optional** if accountId set it will query only that account's transactions
     * @param baseType
     * @param dayInTargetMonth - **optional** any ISO 8601 date for a day within the target month, defaults to server today UTC
     * @param excludeAccountTypes - **optional** blacklist filter by account type
     * @param excludeSubtypes - **optional** blacklist filter by subtype
     * @param excludeTags - **optional** blacklist filter by tag
     * @param excludeTypes - **optional** blacklist filter by type
     * @param includeAccountTypes - **optional** whitelist filter by account type
     * @param includeSubtypes - **optional** whitelist filter by subtype
     * @param includeTags - **optional** whitelist filter by tag
     * @param includeTypes - **optional** whitelist filter by type
     * @param merchantName - **optional** filter by merchant name substring
     * @param status - **optional** filter by transaction status
     * @param serverRequest
     *
     * @return {Promise} Rollups of the form:
     * {
     *  'omit': float,
     *  'income': float,
     *  'bill': float,
     *  'food': float,
     *  'transport': float,
     *  'other': float,
     * }
     */
    getTransactionsSummaryByCategory: function getTransactionsSummaryByCategory() {
      var _ref24 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          accountId = _ref24.accountId,
          baseType = _ref24.baseType,
          dayInTargetMonth = _ref24.dayInTargetMonth,
          excludeAccountTypes = _ref24.excludeAccountTypes,
          excludeSubtypes = _ref24.excludeSubtypes,
          excludeTags = _ref24.excludeTags,
          excludeTypes = _ref24.excludeTypes,
          includeAccountTypes = _ref24.includeAccountTypes,
          includeSubtypes = _ref24.includeSubtypes,
          includeTags = _ref24.includeTags,
          includeTypes = _ref24.includeTypes,
          merchantName = _ref24.merchantName,
          serverRequest = _ref24.serverRequest,
          status = _ref24.status;

      if (process.env !== 'production') {
        // eslint-disable-next-line no-console -- directive added automatically by Shepherd migration
        console.warn('getTransactionsSummaryByCategory is deprecated. Use getTransactionsCashFlowByCategories instead.');
      }

      var params = _omitBy({
        account_id: accountId,
        base_type: baseType,
        day_in_target_month: dayInTargetMonth,
        exclude_account_types: JSON.stringify(excludeAccountTypes),
        exclude_subtypes: JSON.stringify(excludeSubtypes),
        exclude_tags: JSON.stringify(excludeTags),
        exclude_types: JSON.stringify(excludeTypes),
        include_account_types: JSON.stringify(includeAccountTypes),
        include_subtypes: JSON.stringify(includeSubtypes),
        include_tags: JSON.stringify(includeTags),
        include_types: JSON.stringify(includeTypes),
        merchant_name: merchantName,
        status: status
      }, _isNil);

      var url = 'financial_accounts/transactions/summary/by_categories';
      return serviceV1.get(url, params, serverRequest);
    },

    /**
     * Gets a daily rollup of transaction debits for target and previous months.
     *
     * @deprecated Use {@link getDailyTransactionsCashFlow} instead.
     *
     * @param dayInTargetMonth - An ISO 8601 date (defaults to today UTC)
     * @param baseType - Filter by transaction base_type
     * @param serverRequest
     * @param excludeAccountTypes - **optional** blacklist filter by account type
     * @param excludeCategories - **required** blacklist filter by category (should be ['omit'])
     * @param excludeTags - **required** blacklist filter by tag (should be ['ignored'])
     * @param status - **optional** filter by transaction status
     *
     * @return {Promise} Daily rollup of values for target and previous month, in the form { sums_for_previous_month: Object, sums_for_target_month: Object }
     */
    getDailyTransactionsSummary: function getDailyTransactionsSummary() {
      var _ref25 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          dayInTargetMonth = _ref25.dayInTargetMonth,
          baseType = _ref25.baseType,
          excludeAccountTypes = _ref25.excludeAccountTypes,
          excludeCategories = _ref25.excludeCategories,
          excludeTags = _ref25.excludeTags,
          serverRequest = _ref25.serverRequest,
          status = _ref25.status;

      if (process.env !== 'production') {
        // eslint-disable-next-line no-console -- directive added automatically by Shepherd migration
        console.warn('getDailyTransactionsSummary is deprecated. Use getDailyTransactionsCashFlow instead.');
      }

      var params = _omitBy({
        day_in_target_month: dayInTargetMonth,
        base_type: baseType,
        exclude_account_types: JSON.stringify(excludeAccountTypes),
        exclude_categories: JSON.stringify(excludeCategories),
        exclude_tags: JSON.stringify(excludeTags),
        status: status
      }, _isNil);

      var url = 'financial_accounts/transactions/summary/daily';
      return serviceV1.get(url, params, serverRequest);
    },

    /**
     * Gets a summary of transactions grouped by merchant or category
     *
     * @deprecated Use {@link getCashFlowTopSummary} instead.
     *
     * @param accountId - **optional** if accountId set it will query only that account's transactions
     * @param dayInTargetMonth - **required IF includeSlices has 'monthly' or 'weekly'** An ISO 8601 date (defaults to today UTC) to set when the monthly and weekly return values are drawn from
     * @param baseType - **required** Filter by transaction base_type
     * @param serverRequest
     * @param endDate - **required IF includeSlices has 'window'** YYYY-MM-DD
     * @param excludeAccountTypes - **optional** blacklist filter by account type
     * @param excludeCategories - **required** blacklist filter by category (should be ['omit'])
     * @param excludeSubtypes - **optional** blacklist filter by subtype
     * @param excludeTags - **required** blacklist filter by tag (should be ['ignored'])
     * @param excludeTypes - **optional** blacklist filter by type
     * @param groupBy - **required** one of TRANSACTION_GROUP_BYS
     * @param includeAccountTypes - **optional** whitelist filter by account type
     * @param includeCategories - **optional** whitelist filter by category
     * @param includeSlices - **required** list of ['window', 'monthly', 'weekly'] (at least 1 of these required) from TRANSACTION_SLICES
     * @param includeSubtypes - **optional** whitelist filter by subtype
     * @param includeTags - **optional** whitelist filter by tag
     * @param includeTypes - **optional** whitelist filter by type
     * @param limit - **optional but recommended** the max number of merchants to get back
     * @param merchantName - **optional** filter by merchant name substring
     * @param startDate - ** required IF includeSlices has window ** YYYY-MM-DD
     * @param status - **optional** filter by transaction status
     *
     * @return {Promise} Rollups by merchant or category, in the form
     * {
     *  monthly: null | [{
     *    month: '2018-02-01',
     *    top_sums: [X]
     *  }, {
     *    month: '2018-03-01',
     *    top_sums: [X]
     * }],
     *  weekly: null | [{
     *       week: '2018-03-01',
     *       top_sums: [X]
     *    }, {
     *      week: '2018-03-08',
     *      top_sums: [X]
     *  }, {
     *       week: '2018-03-15',
     *       top_sums: [X]
     *    }, {
     *      week: '2018-03-22',
     *      top_sums: [X]
     *  }],
     *  window: null | [X],
     * }
     * where null if slice is not part of includeSlices, and X is of the form:
     * {
     *   merchant_name: 'Lyft',
     *   sum_amount: 13.37,
     * }, {
     *   merchant_name: 'Uber',
     *   sum_amount: 4.20,
     * }, ... up to n items, highest sum first
     */
    getTransactionsSummaryTopGroupedBy: function getTransactionsSummaryTopGroupedBy() {
      var _ref26 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          accountId = _ref26.accountId,
          baseType = _ref26.baseType,
          dayInTargetMonth = _ref26.dayInTargetMonth,
          endDate = _ref26.endDate,
          excludeAccountTypes = _ref26.excludeAccountTypes,
          excludeCategories = _ref26.excludeCategories,
          excludeSubtypes = _ref26.excludeSubtypes,
          excludeTags = _ref26.excludeTags,
          excludeTypes = _ref26.excludeTypes,
          groupBy = _ref26.groupBy,
          includeAccountTypes = _ref26.includeAccountTypes,
          includeCategories = _ref26.includeCategories,
          includeSlices = _ref26.includeSlices,
          includeSubtypes = _ref26.includeSubtypes,
          includeTags = _ref26.includeTags,
          includeTypes = _ref26.includeTypes,
          limit = _ref26.limit,
          merchantName = _ref26.merchantName,
          serverRequest = _ref26.serverRequest,
          startDate = _ref26.startDate,
          status = _ref26.status;

      if (process.env !== 'production') {
        // eslint-disable-next-line no-console -- directive added automatically by Shepherd migration
        console.warn('getTransactionsSummaryTopGroupedBy is deprecated. Use getCashFlowTopSummary instead.');
      }

      var params = _omitBy({
        account_id: accountId,
        base_type: baseType,
        day_in_target_month: dayInTargetMonth,
        end_date: endDate,
        exclude_account_types: JSON.stringify(excludeAccountTypes),
        exclude_categories: JSON.stringify(excludeCategories),
        exclude_subtypes: JSON.stringify(excludeSubtypes),
        exclude_tags: JSON.stringify(excludeTags),
        exclude_types: JSON.stringify(excludeTypes),
        group_by: groupBy,
        include_account_types: JSON.stringify(includeAccountTypes),
        include_categories: JSON.stringify(includeCategories),
        include_slices: JSON.stringify(includeSlices),
        include_subtypes: JSON.stringify(includeSubtypes),
        include_tags: JSON.stringify(includeTags),
        include_types: JSON.stringify(includeTypes),
        limit: limit,
        merchant_name: merchantName,
        start_date: startDate,
        status: status
      }, _isNil);

      var url = 'financial_accounts/transactions/summary/top';
      return serviceV1.get(url, params, serverRequest);
    },

    /**
     * Gets the estimated income and spending for a given month.
     *
     * @deprecated Use {@link getCashFlowProjection} instead.
     *
     * @param {string} dayInTargetMonth An ISO 8601 date (defaults to today UTC)
     * @param {Object} serverRequest The Request object
     *
     * @return {Promise} Returns an object containing estimated income and expenses
     */
    getTransactionsInsAndOuts: function getTransactionsInsAndOuts() {
      var _ref27 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          dayInTargetMonth = _ref27.dayInTargetMonth,
          serverRequest = _ref27.serverRequest;

      if (process.env !== 'production') {
        // eslint-disable-next-line no-console -- directive added automatically by Shepherd migration
        console.warn('getTransactionsInsAndOuts is deprecated. Use getCashFlowProjection instead.');
      }

      var params = _omitBy({
        day_in_target_month: dayInTargetMonth
      }, _isNil);

      var url = 'financial_accounts/transactions/ins_and_outs';
      return serviceV1.get(url, params, serverRequest);
    },

    /**
     * @typedef {Object} TransactionsCashFlow
     * @property {number} spending Net total of transaction amounts across spending categories (= all categories except INCOME and TRANSFERS)
     * @property {number} earning Net total of transaction amounts in the INCOME category
     */

    /**
     * Returns the spending and earning of transaction amounts for the given time period.
     *
     * For a _monthly_ breakdown of spending and earning, see {@link getTransactionsCashFlowMonthly}.
     *
     * @param {Object} params
     * @param {String=} params.accountId - Account ID by which to filter transactions
     * @param {String=} params.canonicalMerchantName - Filter by canonical merchant name
     * @param {number=} params.categoryVersion - Specifies category version to use (default is 1)
     * @param {String=} params.endDate - Inclusive end date (ISO 8601 date, no time). Defaults to today.
     * @param {Array=} params.excludeAccountTypes - Blacklist filter by account types
     * @param {Array=} params.excludeSubtypes - Blacklist filter by subtypes
     * @param {Array=} params.excludeTags - Blacklist filter by tags
     * @param {Array=} params.excludeTypes - Blacklist filter by types
     * @param {Array=} params.includeAccountTypes - Whitelist filter by account types
     * @param {boolean=} params.includeDisabledAccounts - Whether to include transactions from accounts that have nw_enabled=false in calculations
     * @param {Array=} params.includeSubtypes - Whitelist filter by subtypes
     * @param {Array=} params.includeTags - Whitelist filter by tags
     * @param {Array=} params.includeTypes - Whitelist filter by types
     * @param {String=} params.merchantName - Filter by merchant name substring
     * @param {Object=} params.serverRequest - The server request
     * @param {String=} params.startDate - Inclusive start date (ISO 8601 date, no time). Defaults to 30 days before today.
     * @param {String=} params.status - Filter by transaction status
     *
     * @return {Promise} {TransactionsCashFlow}
     */
    getTransactionsCashFlow: function getTransactionsCashFlow() {
      var _ref28 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          accountId = _ref28.accountId,
          canonicalMerchantName = _ref28.canonicalMerchantName,
          _ref28$categoryVersio = _ref28.categoryVersion,
          categoryVersion = _ref28$categoryVersio === void 0 ? 1 : _ref28$categoryVersio,
          endDate = _ref28.endDate,
          excludeAccountTypes = _ref28.excludeAccountTypes,
          excludeSubtypes = _ref28.excludeSubtypes,
          excludeTags = _ref28.excludeTags,
          excludeTypes = _ref28.excludeTypes,
          includeAccountTypes = _ref28.includeAccountTypes,
          includeDisabledAccounts = _ref28.includeDisabledAccounts,
          includeSubtypes = _ref28.includeSubtypes,
          includeTags = _ref28.includeTags,
          includeTypes = _ref28.includeTypes,
          merchantName = _ref28.merchantName,
          serverRequest = _ref28.serverRequest,
          startDate = _ref28.startDate,
          status = _ref28.status;

      var params = _omitBy({
        account_id: accountId,
        canonical_merchant_name: canonicalMerchantName,
        category_version: categoryVersion,
        end_date: endDate,
        exclude_account_types: JSON.stringify(excludeAccountTypes),
        exclude_subtypes: JSON.stringify(excludeSubtypes),
        exclude_tags: JSON.stringify(excludeTags),
        exclude_types: JSON.stringify(excludeTypes),
        include_account_types: JSON.stringify(includeAccountTypes),
        include_subtypes: JSON.stringify(includeSubtypes),
        include_tags: JSON.stringify(includeTags),
        include_types: JSON.stringify(includeTypes),
        merchant_name: merchantName,
        show_nw_disabled: includeDisabledAccounts,
        start_date: startDate,
        status: status
      }, _isNil);

      var url = 'financial_accounts/transactions/cash_flow';
      return serviceV1.get(url, params, serverRequest);
    },

    /**
     * Returns the spending and earning for each calendar month in the given date range.
     *
     * @param {Object} params
     * @param {String=} params.accountId - Account ID by which to filter transactions
     * @param {String=} params.canonicalMerchantName - Filter by canonical merchant name
     * @param {number=} params.categoryVersion - Specifies category version to use (default is 1)
     * @param {String=} params.dayInEndMonth - Date in target start month. Defaults to today in UTC.
     * @param {String=} params.dayInStartMonth - Date in target end month. Defaults to today in UTC.
     * @param {Array=} params.excludeAccountTypes - Blacklist filter by account types
     * @param {Array=} params.excludeSubtypes - Blacklist filter by subtypes
     * @param {Array=} params.excludeTags - Blacklist filter by tags
     * @param {Array=} params.excludeTypes - Blacklist filter by types
     * @param {Array=} params.includeAccountTypes - Whitelist filter by account types
     * @param {Array=} params.includeSubtypes - Whitelist filter by subtypes
     * @param {Array=} params.includeTags - Whitelist filter by tags
     * @param {Array=} params.includeTypes - Whitelist filter by types
     * @param {String=} params.merchantName - Filter by merchant name substring
     * @param {Object=} params.serverRequest - The server request
     * @param {String=} params.status - Filter by transaction status
     *
     * @return {Promise} Object containing cash flow for each month in date range, e.g.
     * {
     *   "2019-01-01": TransactionsCashFlow,
     *   "2019-02-01": TransactionsCashFlow,
     *   "2019-03-01": TransactionsCashFlow
     *   ...
     * }
     */
    getTransactionsCashFlowMonthly: function getTransactionsCashFlowMonthly() {
      var _ref29 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          accountId = _ref29.accountId,
          canonicalMerchantName = _ref29.canonicalMerchantName,
          categoryVersion = _ref29.categoryVersion,
          dayInEndMonth = _ref29.dayInEndMonth,
          dayInStartMonth = _ref29.dayInStartMonth,
          excludeAccountTypes = _ref29.excludeAccountTypes,
          excludeSubtypes = _ref29.excludeSubtypes,
          excludeTags = _ref29.excludeTags,
          excludeTypes = _ref29.excludeTypes,
          includeAccountTypes = _ref29.includeAccountTypes,
          includeSubtypes = _ref29.includeSubtypes,
          includeTags = _ref29.includeTags,
          includeTypes = _ref29.includeTypes,
          merchantName = _ref29.merchantName,
          serverRequest = _ref29.serverRequest,
          status = _ref29.status;

      var params = _omitBy({
        account_id: accountId,
        canonical_merchant_name: canonicalMerchantName,
        category_version: categoryVersion,
        day_in_end_month: dayInEndMonth,
        day_in_start_month: dayInStartMonth,
        exclude_account_types: JSON.stringify(excludeAccountTypes),
        exclude_subtypes: JSON.stringify(excludeSubtypes),
        exclude_tags: JSON.stringify(excludeTags),
        exclude_types: JSON.stringify(excludeTypes),
        include_account_types: JSON.stringify(includeAccountTypes),
        include_subtypes: JSON.stringify(includeSubtypes),
        include_tags: JSON.stringify(includeTags),
        include_types: JSON.stringify(includeTypes),
        merchant_name: merchantName,
        status: status
      }, _isNil);

      var url = 'financial_accounts/transactions/cash_flow/monthly';
      return serviceV1.get(url, params, serverRequest);
    },

    /**
     * Returns the net total of transaction amounts for ALL categories.
     *
     * @param {Object} params
     * @param {String=} params.accountId - Account ID by which to filter transactions
     * @param {String=} params.canonicalMerchantName - Filter by canonical merchant name
     * @param {number=} params.categoryVersion - Specifies category version to use (default is 1)
     * @param {Array=} params.excludeAccountTypes-  Blacklist filter by account types
     * @param {Array=} params.excludeSubtypes - Blacklist filter by subtypes
     * @param {Array=} params.excludeTags - Blacklist filter by tags
     * @param {Array=} params.excludeTypes - Blacklist filter by types
     * @param {Array=} params.includeAccountTypes - Whitelist filter by account types
     * @param {Array=} params.includeSubtypes - Whitelist filter by subtypes
     * @param {Array=} params.includeTags - Whitelist filter by tags
     * @param {Array=} params.includeTypes - Whitelist filter by types
     * @param {String=} params.merchantName - Filter by merchant name substring
     * @param {Object=} params.serverRequest - The server request
     * @param {String=} params.status - Filter by transaction status
     *
     * @return {Promise} Keys are category name, values are amounts.
     *
     * For example:
     * {{ bill: number, food: number, income: number, other: number, transport: number }}
     */
    getTransactionsCashFlowByCategories: function getTransactionsCashFlowByCategories() {
      var _ref30 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          accountId = _ref30.accountId,
          canonicalMerchantName = _ref30.canonicalMerchantName,
          _ref30$categoryVersio = _ref30.categoryVersion,
          categoryVersion = _ref30$categoryVersio === void 0 ? 1 : _ref30$categoryVersio,
          dayInTargetMonth = _ref30.dayInTargetMonth,
          excludeAccountTypes = _ref30.excludeAccountTypes,
          excludeSubtypes = _ref30.excludeSubtypes,
          excludeTags = _ref30.excludeTags,
          excludeTypes = _ref30.excludeTypes,
          includeAccountTypes = _ref30.includeAccountTypes,
          includeSubtypes = _ref30.includeSubtypes,
          includeTags = _ref30.includeTags,
          includeTypes = _ref30.includeTypes,
          merchantName = _ref30.merchantName,
          serverRequest = _ref30.serverRequest,
          status = _ref30.status;

      var params = _omitBy({
        account_id: accountId,
        canonical_merchant_name: canonicalMerchantName,
        category_version: categoryVersion,
        day_in_target_month: dayInTargetMonth,
        exclude_account_types: JSON.stringify(excludeAccountTypes),
        exclude_subtypes: JSON.stringify(excludeSubtypes),
        exclude_tags: JSON.stringify(excludeTags),
        exclude_types: JSON.stringify(excludeTypes),
        include_account_types: JSON.stringify(includeAccountTypes),
        include_subtypes: JSON.stringify(includeSubtypes),
        include_tags: JSON.stringify(includeTags),
        include_types: JSON.stringify(includeTypes),
        merchant_name: merchantName,
        status: status
      }, _isNil);

      var url = 'financial_accounts/transactions/cash_flow/by_categories';
      return serviceV1.get(url, params, serverRequest);
    },

    /**
     * Returns the net total of transaction amounts for each calendar month in a given date range.
     *
     * Warning:
     * If neither `include_categories` nor `exclude_categories` are defined, the result will
     * calculate over _all_ categories, including income/transfers, which is probably not what
     * you want. See {@link getTransactionsCashFlowMonthly} instead.
     *
     * @param {Object} params
     * @param {String=} params.accountId - Account ID by which to filter transactions
     * @param {String=} params.canonicalMerchantName - Filter by canonical merchant name
     * @param {number=} params.categoryVersion - Specifies category version to use (note: v1 is unsupported)
     * @param {String=} params.dayInEndMonth - Date in target start month. Defaults to today in UTC.
     * @param {String=} params.dayInStartMonth - Date in target end month. Defaults to today in UTC.
     * @param {Array=} params.excludeAccountTypes - Blacklist filter by account types
     * @param {Array=} params.excludeCategories - Blacklist filter by category
     * @param {Array=} params.excludeSubtypes - Blacklist filter by subtypes
     * @param {Array=} params.excludeTags - Blacklist filter by tags
     * @param {Array=} params.excludeTypes - Blacklist filter by types
     * @param {Array=} params.includeAccountTypes-  Whitelist filter by account types
     * @param {Array=} params.includeCategories - Whitelist filter by category
     * @param {Array=} params.includeSubtypes - Whitelist filter by subtypes
     * @param {Array=} params.includeTags - Whitelist filter by tags
     * @param {Array=} params.includeTypes - Whitelist filter by types
     * @param {String=} params.merchantName - Filter by merchant name substring
     * @param {Object=} params.serverRequest - The server request
     * @param {String=} params.status - Filter by transaction status
     *
     * @return {Promise} Object containing cash flow for each month in date range, e.g.
     * {
     *   "2019-01-01": 577.75,
     *   "2019-06-01": 184.64,
     *   "2019-02-01": 19.98,
     *   ...
     * }
     */
    getTransactionsSpendingMonthly: function getTransactionsSpendingMonthly() {
      var _ref31 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          accountId = _ref31.accountId,
          canonicalMerchantName = _ref31.canonicalMerchantName,
          _ref31$categoryVersio = _ref31.categoryVersion,
          categoryVersion = _ref31$categoryVersio === void 0 ? 2 : _ref31$categoryVersio,
          dayInEndMonth = _ref31.dayInEndMonth,
          dayInStartMonth = _ref31.dayInStartMonth,
          excludeAccountTypes = _ref31.excludeAccountTypes,
          excludeCategories = _ref31.excludeCategories,
          excludeSubtypes = _ref31.excludeSubtypes,
          excludeTags = _ref31.excludeTags,
          excludeTypes = _ref31.excludeTypes,
          includeAccountTypes = _ref31.includeAccountTypes,
          includeCategories = _ref31.includeCategories,
          includeSubtypes = _ref31.includeSubtypes,
          includeTags = _ref31.includeTags,
          includeTypes = _ref31.includeTypes,
          merchantName = _ref31.merchantName,
          serverRequest = _ref31.serverRequest,
          status = _ref31.status;

      var params = _omitBy({
        account_id: accountId,
        canonical_merchant_name: canonicalMerchantName,
        category_version: categoryVersion,
        day_in_end_month: dayInEndMonth,
        day_in_start_month: dayInStartMonth,
        exclude_account_types: JSON.stringify(excludeAccountTypes),
        exclude_categories_v2: JSON.stringify(excludeCategories),
        exclude_subtypes: JSON.stringify(excludeSubtypes),
        exclude_tags: JSON.stringify(excludeTags),
        exclude_types: JSON.stringify(excludeTypes),
        include_account_types: JSON.stringify(includeAccountTypes),
        include_categories_v2: JSON.stringify(includeCategories),
        include_subtypes: JSON.stringify(includeSubtypes),
        include_tags: JSON.stringify(includeTags),
        include_types: JSON.stringify(includeTypes),
        merchant_name: merchantName,
        status: status
      }, _isNil);

      var url = 'financial_accounts/transactions/spending/monthly';
      return serviceV1.get(url, params, serverRequest);
    },

    /**
     * Returns the net total of transaction amounts for each day in the target and previous months.
     *
     * @param {Object} params
     * @param {String=} params.accountId Account ID by which to filter transactions
     * @param {String=} params.canonicalMerchantName Filter by canonical merchant name
     * @param {number=} params.categoryVersion - Specifies category version to use (default is 1)
     * @param {String=} params.dayInTargetMonth Date (ISO 8601) for a day within the target month. Defaults to today in UTC.
     * @param {Array=} params.excludeAccountTypes Blacklist filter by account types
     * @param {Array=} params.excludeSubtypes Blacklist filter by subtypes
     * @param {Array=} params.excludeTags Blacklist filter by tags
     * @param {Array=} params.excludeTypes Blacklist filter by types
     * @param {Array=} params.includeAccountTypes Whitelist filter by account types
     * @param {Array=} params.includeSubtypes Whitelist filter by subtypes
     * @param {Array=} params.includeTags Whitelist filter by tags
     * @param {Array=} params.includeTypes Whitelist filter by types
     * @param {String=} params.merchantName Filter by merchant name substring
     * @param {Object=} params.serverRequest The server request
     * @param {String=} params.status Filter by transaction status
     *
     * @return {Promise} {{ spending_target_month: Object, spending_prior_month: Object, cum_spending_target_month: Number, cum_spending_prior_month: Number }}
     *
     * spending_target_month is the object:
     * {
     *   "2018-09-01" (first of target month): Number,
     *   ...
     *   min(today, "2018-09-30" (last day of month)): Number
     * }
     *
     * spending_prior_month is the object:
     * {
     *   "2018-08-01" (first day of month before target month): Number,
     *   ...
     *   "2018-08-31" (last day of month): Number
     * }
     */
    getDailyTransactionsCashFlow: function getDailyTransactionsCashFlow() {
      var _ref32 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          accountId = _ref32.accountId,
          canonicalMerchantName = _ref32.canonicalMerchantName,
          _ref32$categoryVersio = _ref32.categoryVersion,
          categoryVersion = _ref32$categoryVersio === void 0 ? 1 : _ref32$categoryVersio,
          dayInTargetMonth = _ref32.dayInTargetMonth,
          excludeAccountTypes = _ref32.excludeAccountTypes,
          excludeSubtypes = _ref32.excludeSubtypes,
          excludeTags = _ref32.excludeTags,
          excludeTypes = _ref32.excludeTypes,
          includeAccountTypes = _ref32.includeAccountTypes,
          includeSubtypes = _ref32.includeSubtypes,
          includeTags = _ref32.includeTags,
          includeTypes = _ref32.includeTypes,
          merchantName = _ref32.merchantName,
          serverRequest = _ref32.serverRequest,
          status = _ref32.status;

      var params = _omitBy({
        account_id: accountId,
        canonical_merchant_name: canonicalMerchantName,
        category_version: categoryVersion,
        day_in_target_month: dayInTargetMonth,
        exclude_account_types: JSON.stringify(excludeAccountTypes),
        exclude_subtypes: JSON.stringify(excludeSubtypes),
        exclude_tags: JSON.stringify(excludeTags),
        exclude_types: JSON.stringify(excludeTypes),
        include_account_types: JSON.stringify(includeAccountTypes),
        include_subtypes: JSON.stringify(includeSubtypes),
        include_tags: JSON.stringify(includeTags),
        include_types: JSON.stringify(includeTypes),
        merchant_name: merchantName,
        status: status
      }, _isNil);

      var url = 'financial_accounts/transactions/cash_flow/daily';
      return serviceV1.get(url, params, serverRequest);
    },

    /**
     * Returns the average monthly spending and average spending per day over the selected months.
     *
     * @param {Object} params
     * @param {String=} params.accountId - Account ID by which to filter transactions
     * @param {String=} params.canonicalMerchantName - Filter by canonical merchant name
     * @param {number=} params.categoryVersion - Specifies category version to use (default is 1)
     * @param {String=} params.dayInEndMonth - Date in target start month. Defaults to today in UTC.
     * @param {String=} params.dayInStartMonth - Date in target end month. Defaults to today in UTC.
     * @param {Array=} params.excludeAccountTypes - Blacklist filter by account types
     * @param {Array=} params.excludeSubtypes - Blacklist filter by subtypes
     * @param {Array=} params.excludeTags - Blacklist filter by tags
     * @param {Array=} params.excludeTypes - Blacklist filter by types
     * @param {Array=} params.includeAccountTypes - Whitelist filter by account types
     * @param {Array=} params.includeSubtypes - Whitelist filter by subtypes
     * @param {Array=} params.includeTags - Whitelist filter by tags
     * @param {Array=} params.includeTypes - Whitelist filter by types
     * @param {String=} params.merchantName - Filter by merchant name substring
     * @param {Object=} params.serverRequest - The server request
     * @param {String=} params.status - Filter by transaction status
     *
     * @return {Promise} Object containing average monthly spending and average spending per day
     * {
     *   "average_monthly_spending": float,
     *   "average_spending_per_day": {
     *     "1": float, // average spending on the nth day of each requested month
     *     "2": float,
     *     "3": float,
     *     ...
     *     "31": float // always contains exactly 31 items
     * }
     */
    getDailyAverageTransactionsCashFlow: function getDailyAverageTransactionsCashFlow() {
      var _ref33 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          accountId = _ref33.accountId,
          canonicalMerchantName = _ref33.canonicalMerchantName,
          categoryVersion = _ref33.categoryVersion,
          dayInEndMonth = _ref33.dayInEndMonth,
          dayInStartMonth = _ref33.dayInStartMonth,
          excludeAccountTypes = _ref33.excludeAccountTypes,
          excludeSubtypes = _ref33.excludeSubtypes,
          excludeTags = _ref33.excludeTags,
          excludeTypes = _ref33.excludeTypes,
          includeAccountTypes = _ref33.includeAccountTypes,
          includeSubtypes = _ref33.includeSubtypes,
          includeTags = _ref33.includeTags,
          includeTypes = _ref33.includeTypes,
          merchantName = _ref33.merchantName,
          serverRequest = _ref33.serverRequest,
          status = _ref33.status;

      var params = _omitBy({
        account_id: accountId,
        canonical_merchant_name: canonicalMerchantName,
        category_version: categoryVersion,
        day_in_end_month: dayInEndMonth,
        day_in_start_month: dayInStartMonth,
        exclude_account_types: JSON.stringify(excludeAccountTypes),
        exclude_subtypes: JSON.stringify(excludeSubtypes),
        exclude_tags: JSON.stringify(excludeTags),
        exclude_types: JSON.stringify(excludeTypes),
        include_account_types: JSON.stringify(includeAccountTypes),
        include_subtypes: JSON.stringify(includeSubtypes),
        include_tags: JSON.stringify(includeTags),
        include_types: JSON.stringify(includeTypes),
        merchant_name: merchantName,
        status: status
      }, _isNil);

      var url = 'financial_accounts/transactions/cash_flow/daily/average';
      return serviceV1.get(url, params, serverRequest);
    },

    /**
     * Gets the projected (estimated) earning and spending for a given month.
     *
     * @param {Object} params
     * @param {number=} params.categoryVersion - Specifies category version to use (default is 1)
     * @param {String=} params.dayInTargetMonth Date (ISO 8601) for a day within the target month. Defaults to today in UTC.
     * @param {Object=} params.serverRequest The server request
     *
     * @return {Promise} {{ projected_earning: Number, projected_bill_spending: Number }}
     */
    getCashFlowProjection: function getCashFlowProjection() {
      var _ref34 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref34$categoryVersio = _ref34.categoryVersion,
          categoryVersion = _ref34$categoryVersio === void 0 ? 1 : _ref34$categoryVersio,
          dayInTargetMonth = _ref34.dayInTargetMonth,
          serverRequest = _ref34.serverRequest;

      var params = _omitBy({
        category_version: categoryVersion,
        day_in_target_month: dayInTargetMonth
      }, _isNil);

      var url = 'financial_accounts/transactions/cash_flow/projection';
      return serviceV1.get(url, params, serverRequest);
    },

    /**
     * Gets a summary of transactions grouped by an arbitrary filter.
     *
     * @param {string=} accountId - Filters results by given account ID
     * @param {string=} canonicalMerchantName - Filter by canoncial merchant name substring
     * @param {string=} category - Filter by transaction category
     * @param {number=} categoryVersion - Specifies category version to use (default is 1)
     * @param {string=} dayInTargetMonth - Required if `includeSlices` has 'monthly' or 'weekly'. Date as YYYY-MM-DD (default: today's date UTC)
     * @param {string=} endDate - Required if `includeSlices` has `window`. Date as YYYY-MM-DD.
     * @param {Array=} excludeAccountTypes - Blacklist filter by account type
     * @param {Array=} excludeCategories - Blacklist filter by category (typically contains "omit" or "transfers"). Respects category version.
     * @param {Array=} excludeSubtypes - Blacklist filter by subtype
     * @param {Array=} excludeTags - Blacklist filter by tag (typically contains "ignored")
     * @param {Array=} excludeTypes - Blacklist filter by type
     * @param {string} groupBy - One of {@link TRANSACTION_GROUP_BYS}
     * @param {Array=} includeAccountTypes - Whitelist filter by account type
     * @param {Array=} includeCategories - Whitelist filter by category. Respects category version.
     * @param {Array} includeSlices - Must contain at least one of {@link TRANSACTION_SLICES}
     * @param {Array=} includeSubtypes - Whitelist filter by subtype
     * @param {Array=} includeTags - Whitelist filter by tag
     * @param {Array=} includeTypes - Whitelist filter by type
     * @param {number=} limit - Max number of results (optional but recommended)
     * @param {object=} serverRequest
     * @param {string=} startDate - Required if `includeSlices` has window. Date as YYYY-MM-DD.
     * @param {string=} status - Filter by transaction status
     *
     * @return {Promise} Rollups by merchant or category, of the form:
     * {
     *  monthly: null | [{
     *    month: '2018-02-01',
     *    top_sums: [X]
     *  }, {
     *    month: '2018-03-01',
     *    top_sums: [X]
     * }],
     *  weekly: null | [{
     *       week: '2018-03-01',
     *       top_sums: [X]
     *    }, {
     *      week: '2018-03-08',
     *      top_sums: [X]
     *  }, {
     *       week: '2018-03-15',
     *       top_sums: [X]
     *    }, {
     *      week: '2018-03-22',
     *      top_sums: [X]
     *  }],
     *  window: null | [X],
     * }
     * where null if slice is not part of includeSlices, and X is of the form:
     * {
     *   merchant_name: 'Lyft',
     *   sum_amount: 13.37,
     * }, {
     *   merchant_name: 'Uber',
     *   sum_amount: 4.20,
     * }, ... up to n items, highest sum first
     */
    getCashFlowTopSummary: function getCashFlowTopSummary() {
      var _ref35 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          accountId = _ref35.accountId,
          canonicalMerchantName = _ref35.canonicalMerchantName,
          category = _ref35.category,
          _ref35$categoryVersio = _ref35.categoryVersion,
          categoryVersion = _ref35$categoryVersio === void 0 ? 1 : _ref35$categoryVersio,
          dayInTargetMonth = _ref35.dayInTargetMonth,
          endDate = _ref35.endDate,
          excludeAccountTypes = _ref35.excludeAccountTypes,
          excludeCategories = _ref35.excludeCategories,
          excludeSubtypes = _ref35.excludeSubtypes,
          excludeTags = _ref35.excludeTags,
          excludeTypes = _ref35.excludeTypes,
          groupBy = _ref35.groupBy,
          includeAccountTypes = _ref35.includeAccountTypes,
          includeCategories = _ref35.includeCategories,
          includeSlices = _ref35.includeSlices,
          includeSubtypes = _ref35.includeSubtypes,
          includeTags = _ref35.includeTags,
          includeTypes = _ref35.includeTypes,
          limit = _ref35.limit,
          serverRequest = _ref35.serverRequest,
          startDate = _ref35.startDate,
          status = _ref35.status;

      var params = _omitBy({
        account_id: accountId,
        canonical_merchant_name: canonicalMerchantName,
        category: categoryVersion === 1 ? category : null,
        category_v2: categoryVersion === 2 ? category : null,
        category_version: categoryVersion,
        day_in_target_month: dayInTargetMonth,
        end_date: endDate,
        exclude_account_types: JSON.stringify(excludeAccountTypes),
        exclude_categories: JSON.stringify(excludeCategories),
        exclude_categories_v2: JSON.stringify(excludeCategories),
        exclude_subtypes: JSON.stringify(excludeSubtypes),
        exclude_tags: JSON.stringify(excludeTags),
        exclude_types: JSON.stringify(excludeTypes),
        group_by: groupBy,
        include_account_types: JSON.stringify(includeAccountTypes),
        include_categories: JSON.stringify(includeCategories),
        include_categories_v2: JSON.stringify(includeCategories),
        include_slices: JSON.stringify(includeSlices),
        include_subtypes: JSON.stringify(includeSubtypes),
        include_tags: JSON.stringify(includeTags),
        include_types: JSON.stringify(includeTypes),
        limit: limit,
        start_date: startDate,
        status: status
      }, _isNil);

      var categoryVersionParams;

      switch (categoryVersion) {
        case 1:
        default:
          {
            categoryVersionParams = _omit(params, ['exclude_categories_v2', 'include_categories_v2']);
            break;
          }

        case 2:
          {
            categoryVersionParams = _omit(params, ['exclude_categories', 'include_categories']);
            break;
          }
      }

      var url = 'financial_accounts/transactions/cash_flow/top';
      return serviceV1.get(url, categoryVersionParams, serverRequest);
    },

    /**
     * Gets a specific transaction by ID
     *
     * @param {Object} params
     * @param {string} params.transactionId - The ID of the transaction to fetch
     * @param {Object=} params.serverRequest
     *
     * @return {Promise}  The specified transaction
     * @see https://github.com/NerdWallet/identity.nerdwallet/blob/master/src/canonical_objects/yodlee_transaction.py
     */
    getTransactionById: function getTransactionById() {
      var _ref36 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          transactionId = _ref36.transactionId,
          serverRequest = _ref36.serverRequest;

      var url = "financial_accounts/transactions/".concat(transactionId);
      return serviceV1.get(url, null, serverRequest);
    },

    /**
     * Get transactions for identity across all accounts in descending order by date,
     * with pending and scheduled transactions before posted ones.
     *
     * @param {Object} params
     * @param {string=} params.accountId - Filter by this account ID
     * @param {string=} params.canonicalMerchantName - Filter  by canonical merchant name (case-insensitive exact match)
     * @param {number=} params.categoryVersion - Specifies category version to use (default is 1)
     * @param {string=} params.endDate - Inclusive end date (ISO 8601 date, no time) of window (default: today)
     * @param {Array=} params.excludeAccountTypes - Blacklist filter by account type
     * @param {Array=} params.excludeCategories - Blacklist filter by category
     * @param {Array=} params.excludeSubtypes - Blacklist filter by subtype
     * @param {Array=} params.excludeTags - Blacklist filter by tag
     * @param {Array=} params.excludeTypes - Blacklist filter by tag
     * @param {Array=} params.includeAccountTypes - Whitelist filter by account type
     * @param {Array=} params.includeCategories  Whitelist filter by category
     * @param {boolean=} params.includeDisabledAccounts - Whether to include transactions for disabled accounts
     * @param {Array=} params.includeSubtypes - Whitelist filter by subtype
     * @param {Array=} params.includeTags - Whitelist filter by tag
     * @param {Array=} params.includeTypes - Whitelist filter by type
     * @param {number} params.limit - Number of transactions to fetch
     * @param {string=} params.merchantName - Filter by merchant name (case-insensitive exact match)
     * @param {number=} params.offset - Number of transactions by which to offset results
     * @param {number=} params.resultsSetToken - Hash of the returned transactions set. If invalid or stale, result set will be of the 0th page.
     * @param {Object=} params.serverRequest
     * @param {string=} params.startDate - Inclusive start date (ISO 8601 date, no time) of window (default 30 days before today)
     * @param {string=} params.status - Filter by transaction status
     * @param {boolean=} params.useGet - Whether to use GET to request transactions (Default uses POST. GETs avoid  server-side POST csrf issues)
     *
     * @return {Promise}  Transactions in the form {'transactions': list of Yodlee transaction canonical objects}
     * @see https://github.com/NerdWallet/identity.nerdwallet/blob/master/src/canonical_objects/yodlee_transaction.py
     */
    getTransactions: function getTransactions() {
      var _ref37 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          accountId = _ref37.accountId,
          canonicalMerchantName = _ref37.canonicalMerchantName,
          _ref37$categoryVersio = _ref37.categoryVersion,
          categoryVersion = _ref37$categoryVersio === void 0 ? 1 : _ref37$categoryVersio,
          endDate = _ref37.endDate,
          excludeAccountTypes = _ref37.excludeAccountTypes,
          excludeCategories = _ref37.excludeCategories,
          excludeSubtypes = _ref37.excludeSubtypes,
          excludeTags = _ref37.excludeTags,
          excludeTypes = _ref37.excludeTypes,
          includeAccountTypes = _ref37.includeAccountTypes,
          includeCategories = _ref37.includeCategories,
          includeDisabledAccounts = _ref37.includeDisabledAccounts,
          includeSubtypes = _ref37.includeSubtypes,
          includeTags = _ref37.includeTags,
          includeTypes = _ref37.includeTypes,
          limit = _ref37.limit,
          merchantName = _ref37.merchantName,
          offset = _ref37.offset,
          resultsSetToken = _ref37.resultsSetToken,
          serverRequest = _ref37.serverRequest,
          startDate = _ref37.startDate,
          status = _ref37.status,
          useGet = _ref37.useGet;

      var params = _omitBy({
        account_id: accountId,
        canonical_merchant_name: canonicalMerchantName,
        category_version: categoryVersion,
        end_date: endDate,
        exclude_account_types: useGet ? JSON.stringify(excludeAccountTypes) : excludeAccountTypes,
        exclude_categories: useGet ? JSON.stringify(excludeCategories) : excludeCategories,
        exclude_categories_v2: useGet ? JSON.stringify(excludeCategories) : excludeCategories,
        exclude_subtypes: useGet ? JSON.stringify(excludeSubtypes) : excludeSubtypes,
        exclude_tags: useGet ? JSON.stringify(excludeTags) : excludeTags,
        exclude_types: useGet ? JSON.stringify(excludeTypes) : excludeTypes,
        include_account_types: useGet ? JSON.stringify(includeAccountTypes) : includeAccountTypes,
        include_categories: useGet ? JSON.stringify(includeCategories) : includeCategories,
        include_categories_v2: useGet ? JSON.stringify(includeCategories) : includeCategories,
        include_subtypes: useGet ? JSON.stringify(includeSubtypes) : includeSubtypes,
        include_tags: useGet ? JSON.stringify(includeTags) : includeTags,
        include_types: useGet ? JSON.stringify(includeTypes) : includeTypes,
        limit: limit,
        merchant_name: merchantName,
        offset: offset,
        results_set_token: resultsSetToken,
        show_nw_disabled: includeDisabledAccounts,
        start_date: startDate,
        status: status
      }, _isNil);

      var categoryVersionParams;

      switch (categoryVersion) {
        case 1:
        default:
          {
            categoryVersionParams = _omit(params, ['exclude_categories_v2', 'include_categories_v2']);
            break;
          }

        case 2:
          {
            categoryVersionParams = _omit(params, ['exclude_categories', 'include_categories']);
            break;
          }
      }

      var url = 'financial_accounts/transactions';
      return (useGet ? serviceV1.get : serviceV1.post)(url, categoryVersionParams, serverRequest);
    },

    /**
     * Retrieves all merchants with whom a user has transactions
     *
     * @param serverRequest
     *
     * @return {Promise} Object in the form {{'merchants': list of all merchants}}
     */
    getMerchants: function getMerchants() {
      var _ref38 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          serverRequest = _ref38.serverRequest;

      var url = 'financial_accounts/transactions/merchants';
      return serviceV1.get(url, null, serverRequest);
    },

    /**
     * Creates merchant category rule override.
     *
     * Possible categories are in TRANSACTION_CATEGORIES
     * @see {@link https://github.com/NerdWallet/identity.nerdwallet/blob/develop/src/canonical_objects/yodlee_category_rule.py}
     *
     * Note: Passing a `transactionId` instead of `canonicalMerchantName` will delete the
     * individual category override of the target transaction, if it exists.
     *
     * @param {string=} transactionId
     * @param {string=} canonicalMerchantName
     * @param {string} category
     * @param {number=} categoryVersion - Specifies category version to use (default is 1)
     * @param {Object=} serverRequest
     *
     * @return {Promise} The newly created category rule canonical object
     */
    createMerchantCategoryRule: function createMerchantCategoryRule(_ref39) {
      var canonicalMerchantName = _ref39.canonicalMerchantName,
          category = _ref39.category,
          _ref39$categoryVersio = _ref39.categoryVersion,
          categoryVersion = _ref39$categoryVersio === void 0 ? 1 : _ref39$categoryVersio,
          serverRequest = _ref39.serverRequest,
          transactionId = _ref39.transactionId;

      var params = _omitBy({
        canonical_merchant_name: canonicalMerchantName,
        category: category,
        category_version: categoryVersion,
        transaction_id: transactionId
      }, _isNil);

      var url = 'financial_accounts/category_rules/merchant';
      return serviceV1.post(url, params, serverRequest);
    },

    /**
     * Creates transaction specific category rule override.
     *
     * Possible categories are in TRANSACTION_CATEGORIES
     * @see {@link https://github.com/NerdWallet/identity.nerdwallet/blob/develop/src/canonical_objects/yodlee_category_rule.py}
     *
     * @param {string} transactionId
     * @param {string} category
     * @param {number=} categoryVersion - Specifies category version to use (default is 1)
     * @param {Object=} serverRequest
     *
     * @return {Promise} Newly created category rule canonical object
     */
    createTransactionCategoryRule: function createTransactionCategoryRule(_ref40) {
      var transactionId = _ref40.transactionId,
          category = _ref40.category,
          _ref40$categoryVersio = _ref40.categoryVersion,
          categoryVersion = _ref40$categoryVersio === void 0 ? 1 : _ref40$categoryVersio,
          serverRequest = _ref40.serverRequest;

      var params = _omitBy({
        transaction_id: transactionId,
        category: category,
        category_version: categoryVersion
      }, _isNil);

      var url = 'financial_accounts/category_rules/transaction';
      return serviceV1.post(url, params, serverRequest);
    },

    /**
     * Retrieves all user defined category rule overrides
     *
     * @param serverRequest
     *
     * @return {Promise}
     */
    getCategoryRules: function getCategoryRules() {
      var _ref41 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          serverRequest = _ref41.serverRequest;

      var url = 'financial_accounts/category_rules';
      return serviceV1.get(url, null, serverRequest);
    },

    /**
     * Delete a category rule.
     *
     * @param categoryRuleId
     * @param serverRequest
     *
     * @return {Promise}
     */
    deleteCategoryRule: function deleteCategoryRule() {
      var _ref42 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          categoryRuleId = _ref42.categoryRuleId,
          serverRequest = _ref42.serverRequest;

      var url = "financial_accounts/category_rules/".concat(categoryRuleId);
      return serviceV1.delete(url, {}, serverRequest);
    },

    /**
     * Get spending top takeaways.
     *
     * @param {number=} categoryVersion - Specifies category version to use (default is 1)
     * @param {string} today - Today's date in ISO format
     * @param serverRequest
     *
     * @return {Promise}
     */
    getTopTakeaways: function getTopTakeaways() {
      var _ref43 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref43$categoryVersio = _ref43.categoryVersion,
          categoryVersion = _ref43$categoryVersio === void 0 ? 1 : _ref43$categoryVersio,
          today = _ref43.today,
          serverRequest = _ref43.serverRequest;

      var params = _omitBy({
        today: today,
        category_version: categoryVersion
      }, _isNil);

      var url = 'financial_accounts/top_takeaways';
      return serviceV1.get(url, params, serverRequest);
    },

    /**
     * @param {string} providerAccountStateId Provider account state UUID to delete
     * @param {number} providerAccountId Provider account ID to delete (deprecated; use providerAccountStateId instead)
     * @param {boolean} getYodleeProfile Whether to return the Yodlee profile as part of the response
     * @param serverRequest
     *
     * @return {Promise}
     */
    deleteProviderAccount: function deleteProviderAccount(_ref44) {
      var providerAccountStateId = _ref44.providerAccountStateId,
          providerAccountId = _ref44.providerAccountId,
          getYodleeProfile = _ref44.getYodleeProfile,
          serverRequest = _ref44.serverRequest;

      var params = _omitBy({
        get_yodlee_profile: getYodleeProfile
      }, _isNil);

      var url = "provider_accounts/".concat(providerAccountStateId || providerAccountId);
      return serviceV1.delete(url, params, serverRequest);
    },

    /**
     * Manually refresh a provider account.
     *
     * @param providerAccountStateId
     * @param isAutoRefresh
     * @param serverRequest
     *
     * @return {Promise}
     */
    refreshProviderAccount: function refreshProviderAccount(_ref45) {
      var providerAccountStateId = _ref45.providerAccountStateId,
          isAutoRefresh = _ref45.isAutoRefresh,
          serverRequest = _ref45.serverRequest;
      var url = "provider_accounts/manual_refresh/".concat(providerAccountStateId);
      var body = isAutoRefresh ? {
        auto_refresh: true
      } : {};
      return serviceV1.post(url, body, serverRequest);
    },

    /**
     * Deactivates user's account on Yodlee's end, and deletes YodleeAuthorizationProfile, all
     * provider accounts, and all accounts for an identity.
     *
     * @param serverRequest
     *
     * @return {Promise}
     */
    deactivate: function deactivate() {
      var _ref46 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          serverRequest = _ref46.serverRequest;

      var url = 'deactivate';
      return serviceV1.delete(url, {}, serverRequest);
    }
  }; // ---- Admin Interface ----
  // TODO: add Roles API endpoints here
  // Deactivate (and log out) another identity.
  // - success: function ()
  // - error: function (err, resp, data)

  function deactivateOtherIdentity(identityID, serverRequest) {
    return serviceV1.delete("identities/".concat(identityID), {}, serverRequest);
  }

  function profileUrl(identityID, profileType) {
    return "identities/".concat(identityID, "/profiles/").concat(profileType);
  }

  function productShoppingActionUrl(identityID) {
    return "identities/".concat(identityID, "/product_shopping_actions");
  }

  function getProperties(obj) {
    var props = []; // eslint-disable-next-line no-restricted-syntax

    for (var p in obj) {
      props.push(p);
    }

    return props;
  } // User Data Split Helpers


  function splitIncludeProfiles() {
    var includeProfiles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var identityProfiles = includeProfiles.filter(function (profile) {
      return !isUDPProfile(profile) && !isTUProfile(profile);
    });
    var udpProfiles = includeProfiles.filter(function (profile) {
      return isUDPProfile(profile);
    });
    var tuProfiles = includeProfiles.filter(function (profile) {
      return isTUProfile(profile);
    });
    return {
      identityProfiles: identityProfiles,
      udpProfiles: udpProfiles,
      tuProfiles: tuProfiles
    };
  }

  function removeLogicalModelMetadata(logicalModelData) {
    return logicalModelData ? _omit(logicalModelData, ['_t', '_v']) : logicalModelData;
  }
  /**
   * Handles authentication with Identity and then shims profile fetches to resolve any requested profile data from relevant services.
   * The calls to the profile-backing services will only be made if at least one relevant profile is requested.
   * @param {Promise} identityPromise the authentication request that will return and Identity canonical object/logical model
   * @param {Object} includeProfilesByService mapping of profiles requested to the relevant service
   * @param {*} serverRequest the server request
   * @param {*} identityProfilesPath the path to the profiles map (defaults to 'identity.profiles')
   * @returns the Identity response with the requested profile data resolved
   */


  function handleIdentityWithShimmedProfiles(identityPromise, includeProfilesByService, serverRequest) {
    var identityProfilesPath = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'identity.profiles';
    var identityProfiles = includeProfilesByService.identityProfiles,
        udpProfiles = includeProfilesByService.udpProfiles,
        tuProfiles = includeProfilesByService.tuProfiles; // Resolve the auth request first to ensure that consequent profile fetches wouldn't result in an authentication error.

    return new Promise(function (resolve, reject) {
      identityPromise.then(function (identityResponse) {
        // Create concurrent requests to fetch profiles
        var identityProfilesPromise = null;

        if (identityProfiles.length > 0) {
          var identityProfilesMap = upgradeIncludeProfilesToV2(identityProfiles);
          identityProfilesPromise = getProfilesV2(identityProfilesMap, serverRequest);
        }

        var udpPromise = null;

        if (udpProfiles.length > 0) {
          var udpProfilesMap = upgradeIncludeProfilesToV2(udpProfiles);
          ensureUserDataPlatformSDK();
          udpPromise = userDataPlatformSDK.member.getProfilesV2(udpProfilesMap, serverRequest);
        }

        var tuPromise = null;

        if (tuProfiles.length > 0) {
          var tuProfilesMap = upgradeIncludeProfilesToV2(tuProfiles);
          ensureTransunionSDK();
          tuPromise = transunionSDK.profiles.getProfilesV2(tuProfilesMap, serverRequest);
        }

        Promise.all([identityProfilesPromise, udpPromise, tuPromise]).then(function (responses) {
          // Add profiles to the identity response
          var _responses = _slicedToArray(responses, 3),
              identityProfileResponse = _responses[0],
              udpResponse = _responses[1],
              tuResponse = _responses[2];

          _set(identityResponse, identityProfilesPath, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _get(identityResponse, identityProfilesPath)), _mapValues(identityProfileResponse, removeLogicalModelMetadata)), _mapValues(udpResponse, removeLogicalModelMetadata)), _mapValues(tuResponse, removeLogicalModelMetadata)));

          ServiceSDK.setUserLoggedIn();
          resolve(identityResponse);
        }).catch(reject);
      }).catch(reject);
    });
  }

  return {
    // Constants
    // Exported here in addition to static exports from this module for
    // backwards compatibility.
    ACCOUNT_TYPES: ACCOUNT_TYPES,
    APPS: APPS,
    EMAIL_VERIFICATION_URLS: EMAIL_VERIFICATION_URLS,
    GOAL_SUBTYPES: GOAL_SUBTYPES,
    GOAL_TYPES: GOAL_TYPES,
    PASSWORD_RESET_URLS: PASSWORD_RESET_URLS,
    PROFILES: PROFILES,
    TOS_ACKNOWLEDGEMENT_SOURCE: TOS_ACKNOWLEDGEMENT_SOURCE,
    TOS_ACKNOWLEDGEMENT_TYPE: TOS_ACKNOWLEDGEMENT_TYPE,
    TRANSACTION_BASE_TYPES: TRANSACTION_BASE_TYPES,
    TRANSACTION_CATEGORIES: TRANSACTION_CATEGORIES,
    TRANSACTION_GROUP_BYS: TRANSACTION_GROUP_BYS,
    TRANSACTION_SLICES: TRANSACTION_SLICES,
    TRANSACTION_STATUS: TRANSACTION_STATUS,
    TRANSACTION_TAGS: TRANSACTION_TAGS,
    SELF_REPORTED_CREDIT_SCORE_RANGES: SELF_REPORTED_CREDIT_SCORE_RANGES,
    ONBOARDING_TYPES: ONBOARDING_TYPES,
    ONBOARDING_INTEREST_TYPES: ONBOARDING_INTEREST_TYPES,
    CURRENT_SAVING_PATTERN_TYPES: CURRENT_SAVING_PATTERN_TYPES,
    CURRENT_SPENDING_PATTERN_TYPES: CURRENT_SPENDING_PATTERN_TYPES,
    DEBT_TYPES: DEBT_TYPES,
    SAVING_TYPES: SAVING_TYPES,
    register: register,
    getSecurityQuestions: getSecurityQuestions,
    setSecurityChallenge: setSecurityChallenge,
    lookupSecurityChallenge: lookupSecurityChallenge,
    requestOtpSecret: requestOtpSecret,
    deactivateOtp: deactivateOtp,
    verifyOtpCode: verifyOtpCode,
    generateOtpBackupCodes: generateOtpBackupCodes,
    updateEmail: updateEmail,
    updatePassword: updatePassword,
    createPassword: createPassword,
    resendVerificationEmail: resendVerificationEmail,
    verify: verify,
    sendSmsVerification: sendSmsVerification,
    sendSmsReverification: sendSmsReverification,
    verifySmsCode: verifySmsCode,
    verifyGoogleRecaptcha: verifyGoogleRecaptcha,
    unsubscribe: unsubscribe,
    unsubscribeV2: unsubscribeV2,
    updateSubscription: updateSubscription,
    updateSubscriptionV2: updateSubscriptionV2,
    migrateVerificationRecords: migrateVerificationRecords,
    sendPasswordResetEmail: sendPasswordResetEmail,
    resetPassword: resetPassword,
    deactivate: deactivate,
    deactivateViaToken: deactivateViaToken,
    acknowledgeTOS: acknowledgeTOS,
    setAppLockEnabled: setAppLockEnabled,
    initCsrfSessionFromClient: initCsrfSessionFromClient,
    setGoal: setGoal,
    configureGoal: configureGoal,
    deleteGoal: deleteGoal,
    bespokeStageGetIdentityTokens: bespokeStageGetIdentityTokens,
    bespokeExpireIdentityTokens: bespokeExpireIdentityTokens,
    generateOneTimeCookieIdTransferToken: generateOneTimeCookieIdTransferToken,
    generateOneTimeLoginToken: generateOneTimeLoginToken,
    getLoggedInIdentity: getLoggedInIdentity,
    login: login,
    loginViaApple: loginViaApple,
    loginViaCorpIdp: loginViaCorpIdp,
    loginViaGoogle: loginViaGoogle,
    loginViaOneTimeToken: loginViaOneTimeToken,
    loginViaRefreshToken: loginViaRefreshToken,
    logout: logout,
    adminGetIdentity: adminGetIdentity,
    TUCreditReport: {
      createCustomer: createTUCustomer,
      authenticateCustomer: authenticateTUCustomer,
      enrollCustomer: enrollTUCustomer,
      deactivateCustomer: deactivateTUCustomer,
      getCreditScore: getCreditScore,
      getCreditFactor: getCreditFactor,
      getCreditFactorHistory: getCreditFactorHistory,
      simulateVantageScore: simulateVantageScore,
      getCreditProfileAlert: getCreditProfileAlert,
      getCreditProfileAlerts: getCreditProfileAlerts,
      refreshTUCreditProfile: refreshTUCreditProfile,
      getCreditProfileRecentChanges: getCreditProfileRecentChanges
    },
    Yodlee: Yodlee,
    Admin: {
      deactivateIdentity: deactivateOtherIdentity
    },
    getProfilesV2: getProfilesV2,
    getAnyProfilesV2: getAnyProfilesV2,
    createProfile: createProfile,
    readProfile: readProfile,
    updateProfile: updateProfile,
    deleteProfile: deleteProfile,
    createMyProfile: createMyProfile,
    readMyProfile: readMyProfile,
    updateMyProfile: updateMyProfile,
    deleteMyProfile: deleteMyProfile,
    createAnyProfile: createAnyProfile,
    readAnyProfile: readAnyProfile,
    updateAnyProfile: updateAnyProfile,
    deleteAnyProfile: deleteAnyProfile,
    createMemberOrVisitorProfile: createMemberOrVisitorProfile,
    readMemberOrVisitorProfile: readMemberOrVisitorProfile,
    updateMemberOrVisitorProfile: updateMemberOrVisitorProfile,
    deleteMemberOrVisitorProfile: deleteMemberOrVisitorProfile,
    createMemberOrVisitorProfileV2: createMemberOrVisitorProfileV2,
    readMemberOrVisitorProfileV2: readMemberOrVisitorProfileV2,
    updateMemberOrVisitorProfileV2: updateMemberOrVisitorProfileV2,
    deleteMemberOrVisitorProfileV2: deleteMemberOrVisitorProfileV2,
    updateVisitorEmail: updateVisitorEmail,
    registerVisitor: registerVisitor,
    readMemberProductShoppingActions: readMemberProductShoppingActions,
    createMemberProductShoppingAction: createMemberProductShoppingAction,
    identityRoute: identityRoute
  };
}
export { ACCOUNT_TYPES, APPS, EMAIL_VERIFICATION_URLS, GOAL_SUBTYPES, GOAL_TYPES, PASSWORD_RESET_URLS, PROFILES, TOS_ACKNOWLEDGEMENT_SOURCE, TOS_ACKNOWLEDGEMENT_TYPE, TRANSACTION_BASE_TYPES, TRANSACTION_CATEGORIES, TRANSACTION_GROUP_BYS, TRANSACTION_SLICES, TRANSACTION_STATUS, TRANSACTION_TAGS, ONBOARDING_TYPES, ONBOARDING_INTEREST_TYPES, CURRENT_SAVING_PATTERN_TYPES, CURRENT_SPENDING_PATTERN_TYPES, DEBT_TYPES, SAVING_TYPES, SELF_REPORTED_CREDIT_SCORE_RANGES, PRODUCT_SHOPPING_EVENT_NAMES, PRODUCT_SHOPPING_ACTION_NAMES };
/**
 * Attach exports directly to the default export for backwards compatibility.
 */

IdentitySDK.APPS = APPS;
IdentitySDK.ACCOUNT_TYPES = ACCOUNT_TYPES;
IdentitySDK.EMAIL_VERIFICATION_URLS = EMAIL_VERIFICATION_URLS;
IdentitySDK.GOAL_SUBTYPES = GOAL_SUBTYPES;
IdentitySDK.GOAL_TYPES = GOAL_TYPES;
IdentitySDK.PASSWORD_RESET_URLS = PASSWORD_RESET_URLS;
IdentitySDK.PROFILES = PROFILES;
IdentitySDK.TOS_ACKNOWLEDGEMENT_SOURCE = TOS_ACKNOWLEDGEMENT_SOURCE;
IdentitySDK.TOS_ACKNOWLEDGEMENT_TYPE = TOS_ACKNOWLEDGEMENT_TYPE;
IdentitySDK.TRANSACTION_BASE_TYPES = TRANSACTION_BASE_TYPES;
IdentitySDK.TRANSACTION_CATEGORIES = TRANSACTION_CATEGORIES;
IdentitySDK.TRANSACTION_GROUP_BYS = TRANSACTION_GROUP_BYS;
IdentitySDK.TRANSACTION_SLICES = TRANSACTION_SLICES;
IdentitySDK.TRANSACTION_STATUS = TRANSACTION_STATUS;
IdentitySDK.TRANSACTION_TAGS = TRANSACTION_TAGS;
IdentitySDK.ONBOARDING_TYPES = ONBOARDING_TYPES;
IdentitySDK.ONBOARDING_INTEREST_TYPES = ONBOARDING_INTEREST_TYPES;
IdentitySDK.CURRENT_SAVING_PATTERN_TYPES = CURRENT_SAVING_PATTERN_TYPES;
IdentitySDK.CURRENT_SPENDING_PATTERN_TYPES = CURRENT_SPENDING_PATTERN_TYPES;
IdentitySDK.DEBT_TYPES = DEBT_TYPES;
IdentitySDK.SAVING_TYPES = SAVING_TYPES;
IdentitySDK.SELF_REPORTED_CREDIT_SCORE_RANGES = SELF_REPORTED_CREDIT_SCORE_RANGES;
IdentitySDK.PRODUCT_SHOPPING_EVENT_NAMES = PRODUCT_SHOPPING_EVENT_NAMES;
IdentitySDK.PRODUCT_SHOPPING_ACTION_NAMES = PRODUCT_SHOPPING_ACTION_NAMES;